<template>
  <fragment>
    <g
      id="Eye_type_A-10-3-1-26"
      v-if="data.value === 'type-26' && data.position === 'm'"
    >
      <g>
        <g>
          <path
            fill="#fff"
            d="m179.39,167.68c.65-3.13,11.58-8.91,16-8.16s17.22,7.89,18.45,10.21.66,9.65-3.58,15.03c-3.58,4.55-11.39,7.42-16.75,6.59s-3.73-.45-6.12-1.48-10.54-9.93-8-22.17Z"
          />
          <path
            :fill="data.color"
            d="m205.92,176.22c-.56,8.7-5.23,14.27-11.72,14.27-5.78,0-10.91-6.36-10.91-14.47s2.05-14.75,11.08-14.47c7.43.23,12.11,5.98,11.54,14.68Z"
          />
          <path
            d="m207.1,176.29c-2.32,20.37-24.45,19.07-25.11-1.19-.29-5.55,1.09-12.7,7.14-14.74,3.9-1.31,7.99-1.09,11.59.86,5.31,2.85,7.1,9.7,6.38,15.08h0Zm-2.35-.15c.31-6.28-3.3-12.32-10.01-12.59-7.52-.76-9.73,4.86-10.11,11.61-.29,3.26.23,6.56,1.79,9.45,2.29,4.54,7.72,6.91,12.33,4.28,4.46-2.46,5.89-7.96,6-12.74h0Z"
          />
          <path
            d="m177.46,169.45c1.79-6.38,8.03-12.01,14.98-12.65,11.43-1.18,22.02,7.18,26.25,17.22.21.51-.03,1.1-.55,1.31-.41.17-.87.05-1.14-.27-2.68-2.99-5.56-5.64-8.74-7.74-10.51-7.09-20.48-6.16-29.09,3.13-.7.78-2.05-.03-1.71-1h0Z"
          />
          <ellipse cx="194.42" cy="176.99" rx="4.7" ry="5.48" />
          <path
            d="m215.1,164.74c-.14,0-.28-.06-.38-.17-2.93-3.27-10.79-10.84-20.93-10.84-.08,0-.16,0-.25,0-8.19.1-12.12,4.21-12.16,4.25-.19.21-.52.22-.72.03-.21-.19-.22-.52-.03-.72.17-.18,4.24-4.48,12.9-4.58.09,0,.17,0,.26,0,10.55,0,18.68,7.8,21.7,11.18.19.21.17.54-.04.72-.1.09-.22.13-.34.13Z"
          />
          <path
            d="m204.02,189.17c-2.56,1.83-5.63,2.47-8.71,2.63-3.07-.01-6.18-.38-8.85-2.06-.19-.13-.24-.38-.12-.57.12-.19.36-.23.55-.13,5.26,1.87,11.55,1.78,16.66-.55.43-.27.88.38.47.68h0Z"
          />
          <path
            d="m206.3,188.02c.65,0,4.11,2.16,2.57,2.08-.81-.5-1.75-.99-2.69-1.1-.71-.04-.57-1.13.13-.99h0Z"
          />
          <path
            d="m208.64,186.71c.87.29,1.59.87,2.13,1.47.09.1.08.26-.02.35-.09.08-.22.08-.31.02-.65-.47-1.32-.79-2.04-.88-.73-.1-.46-1.21.24-.96h0Z"
          />
          <path
            d="m215.67,170.02c2.08.72,4.42.88,6.63.84.48-.03.56.71.09.79-2.41.46-4.83.7-7.3.28-.54-.11-.89-.63-.79-1.17.11-.61.78-.97,1.36-.73h0Z"
          />
          <path
            d="m211.38,164.51c2.15.62,4.52.75,6.77.7.22,0,.4.16.41.38,0,.2-.13.37-.32.4-1.77.36-3.59.57-5.41.56-.92-.07-2.88.23-2.76-1.24.08-.61.72-1.01,1.31-.81h0Z"
          />
          <path
            d="m205.75,160.3c2.34.2,4.8-.28,7.01-1.11.2-.08.44.02.52.23.07.18,0,.39-.17.49-1.11.64-2.29,1.17-3.53,1.58-1.3.41-2.51.71-3.91.8-.55.03-1.02-.4-1.05-.95-.04-.62.52-1.13,1.13-1.04h0Z"
          />
          <path
            opacity=".5"
            d="m204.75,171.14c0,4.55-4.47-.25-9.98-.25s-9.98,4.8-9.98.25,4.47-8.24,9.98-8.24,9.98,3.69,9.98,8.24Z"
          />
          <path
            fill="#fff"
            opacity=".5"
            d="m188.25,183.71c-.2-2.87,2.86-.04,6.38-.28s6.16-3.46,6.36-.59-2.49,5.39-6.01,5.63-6.54-1.89-6.74-4.76Z"
          />
        </g>
        <g>
          <path
            fill="#fff"
            d="m140.87,167.68c-.65-3.13-11.58-8.91-16-8.16s-17.22,7.89-18.45,10.21-.66,9.65,3.58,15.03c3.58,4.55,11.39,7.42,16.75,6.59s3.73-.45,6.12-1.48,10.54-9.93,8-22.17Z"
          />
          <g>
            <g>
              <path
                d="m114.34,176.22c.56,8.7,5.23,14.27,11.72,14.27,5.78,0,10.91-6.36,10.91-14.47s-2.05-14.75-11.08-14.47c-7.43.23-12.11,5.98-11.54,14.68Z"
              />
              <path
                d="m113.16,176.29c2.32,20.37,24.45,19.07,25.11-1.19.29-5.55-1.09-12.7-7.14-14.74-3.9-1.31-7.99-1.09-11.59.86-5.31,2.85-7.1,9.7-6.38,15.08h0Zm2.35-.15c-.31-6.28,3.3-12.32,10.01-12.59,7.52-.76,9.73,4.86,10.11,11.61.29,3.26-.23,6.56-1.79,9.45-2.29,4.54-7.72,6.91-12.33,4.28-4.46-2.46-5.89-7.96-6-12.74h0Z"
              />
            </g>
            <g>
              <path
                :fill="data.color"
                d="m114.34,176.22c.56,8.7,5.23,14.27,11.72,14.27,5.78,0,10.91-6.36,10.91-14.47s-2.05-14.75-11.08-14.47c-7.43.23-12.11,5.98-11.54,14.68Z"
              />
              <path
                d="m113.16,176.29c2.32,20.37,24.45,19.07,25.11-1.19.29-5.55-1.09-12.7-7.14-14.74-3.9-1.31-7.99-1.09-11.59.86-5.31,2.85-7.1,9.7-6.38,15.08h0Zm2.35-.15c-.31-6.28,3.3-12.32,10.01-12.59,7.52-.76,9.73,4.86,10.11,11.61.29,3.26-.23,6.56-1.79,9.45-2.29,4.54-7.72,6.91-12.33,4.28-4.46-2.46-5.89-7.96-6-12.74h0Z"
              />
            </g>
          </g>
          <path
            d="m142.8,169.45c-1.79-6.38-8.03-12.01-14.98-12.65-11.43-1.18-22.02,7.18-26.25,17.22-.21.51.03,1.1.55,1.31.41.17.87.05,1.14-.27,2.68-2.99,5.56-5.64,8.74-7.74,10.51-7.09,20.48-6.16,29.09,3.13.7.78,2.05-.03,1.71-1h0Z"
          />
          <ellipse cx="125.84" cy="176.99" rx="4.7" ry="5.48" />
          <path
            d="m105.16,164.74c-.12,0-.24-.04-.34-.13-.21-.19-.23-.51-.04-.72,3.02-3.38,11.14-11.18,21.7-11.18.09,0,.17,0,.26,0,8.66.11,12.73,4.4,12.9,4.58.19.21.18.53-.03.72-.21.19-.53.18-.72-.03-.04-.04-3.97-4.15-12.16-4.25-.08,0-.17,0-.25,0-10.14,0-18.01,7.57-20.93,10.84-.1.11-.24.17-.38.17Z"
          />
          <path
            d="m116.24,189.17c2.56,1.83,5.63,2.47,8.71,2.63,3.07-.01,6.18-.38,8.85-2.06.19-.13.24-.38.12-.57-.12-.19-.36-.23-.55-.13-5.26,1.87-11.55,1.78-16.66-.55-.43-.27-.88.38-.47.68h0Z"
          />
          <path
            d="m113.96,188.02c-.65,0-4.11,2.16-2.57,2.08.81-.5,1.75-.99,2.69-1.1.71-.04.57-1.13-.13-.99h0Z"
          />
          <path
            d="m111.62,186.71c-.87.29-1.59.87-2.13,1.47-.09.1-.08.26.02.35.09.08.22.08.31.02.65-.47,1.32-.79,2.04-.88.73-.1.46-1.21-.24-.96h0Z"
          />
          <path
            d="m104.59,170.02c-2.08.72-4.42.88-6.63.84-.48-.03-.56.71-.09.79,2.41.46,4.83.7,7.3.28.54-.11.89-.63.79-1.17-.11-.61-.78-.97-1.36-.73h0Z"
          />
          <path
            d="m108.88,164.51c-2.15.62-4.52.75-6.77.7-.22,0-.4.16-.41.38,0,.2.13.37.32.4,1.77.36,3.59.57,5.41.56.92-.07,2.88.23,2.76-1.24-.08-.61-.72-1.01-1.31-.81h0Z"
          />
          <path
            d="m114.51,160.3c-2.34.2-4.8-.28-7.01-1.11-.2-.08-.44.02-.52.23-.07.18,0,.39.17.49,1.11.64,2.29,1.17,3.53,1.58,1.3.41,2.51.71,3.91.8.55.03,1.02-.4,1.05-.95.04-.62-.52-1.13-1.13-1.04h0Z"
          />
          <path
            opacity=".5"
            d="m115.51,171.14c0,4.55,4.47-.25,9.98-.25s9.98,4.8,9.98.25-4.47-8.24-9.98-8.24-9.98,3.69-9.98,8.24Z"
          />
          <path
            fill="#fff"
            opacity=".5"
            d="m132.01,183.71c.2-2.87-2.86-.04-6.38-.28s-6.16-3.46-6.36-.59,2.49,5.39,6.01,5.63,6.54-1.89,6.74-4.76Z"
          />
        </g>
        <path
          fill="#fff"
          d="m203.69,172.15c-1.17,2.94-4.79,2.36-8.89.73-4.11-1.63-7.14-3.69-5.97-6.63s5.44-4,9.54-2.37c4.11,1.63,6.49,5.33,5.32,8.27Z"
        />
        <ellipse
          fill="#fff"
          cx="202.84"
          cy="176.07"
          rx="2.52"
          ry="2.29"
          transform="translate(-26.72 36.61) rotate(-9.68)"
        />
        <ellipse
          fill="#fff"
          cx="188.81"
          cy="183.63"
          rx="3.24"
          ry="2.63"
          transform="translate(-59.58 96.04) rotate(-24.78)"
        />
        <path
          fill="#fff"
          d="m203.54,183.41c-2.62.84-3.23,1.52-3.99,4.45-.75-2.92-1.36-3.61-3.99-4.45,2.62-.84,3.23-1.52,3.99-4.45.75,2.92,1.36,3.61,3.99,4.45Z"
        />
        <path
          fill="#fff"
          d="m135.22,172.15c-1.17,2.94-4.79,2.36-8.89.73-4.11-1.63-7.14-3.69-5.97-6.63s5.44-4,9.54-2.37c4.11,1.63,6.49,5.33,5.32,8.27Z"
        />
        <ellipse
          fill="#fff"
          cx="134.37"
          cy="176.07"
          rx="2.52"
          ry="2.29"
          transform="translate(-27.69 25.1) rotate(-9.68)"
        />
        <ellipse
          fill="#fff"
          cx="120.34"
          cy="183.63"
          rx="3.24"
          ry="2.63"
          transform="translate(-65.89 67.35) rotate(-24.78)"
        />
        <path
          fill="#fff"
          d="m135.07,183.41c-2.62.84-3.23,1.52-3.99,4.45-.75-2.92-1.36-3.61-3.99-4.45,2.62-.84,3.23-1.52,3.99-4.45.75,2.92,1.36,3.61,3.99,4.45Z"
        />
      </g>
    </g>
    <g
      id="Eye_type_A-10-3-1-25"
      v-if="data.value === 'type-25' && data.position === 'm'"
    >
      <g>
        <ellipse
          :fill="data.color"
          cx="124.29"
          cy="175.98"
          rx="8.19"
          ry="8.74"
        />
        <ellipse
          :fill="data.color"
          cx="195.71"
          cy="175.98"
          rx="8.19"
          ry="8.74"
        />
      </g>
    </g>
    <g
      id="Eye_type_A-10-3-1-24"
      v-if="data.value === 'type-24' && data.position === 'm'"
    >
      <g>
        <g>
          <path
            opacity=".08"
            d="m176.74,170.03s2.22-15.87,19.38-15.87,19.38,15.87,19.38,15.87h-38.77Z"
          />
          <path
            fill="#fff"
            d="m213.81,172.5c0,8.59-8,15.55-17.87,15.55s-17.87-6.96-17.87-15.55"
          />
          <path
            :fill="data.color"
            d="m183.46,170.94v.73c0,6.74,5.19,12.24,11.62,12.24s11.62-5.5,11.62-12.24v-.73h-23.23Z"
          />
          <path
            d="m188.86,173.66v.41c0,3.63,2.8,6.53,6.22,6.53s6.22-2.9,6.22-6.53v-.41h-12.45Z"
          />
          <g fill="none" opacity=".3">
            <path
              d="m188.86,173.66v.41c0,3.63,2.8,6.53,6.22,6.53s6.22-2.9,6.22-6.53v-.41h-12.45Z"
            />
          </g>
          <path
            d="m176.74,170.03c13.35-.37,27.5-.29,40.85,0,1.72.07,1.73,2.63,0,2.7-11.83.89-23.89,1.04-35.74.43-1.74-.12-3.48-.24-5.22-.44-1.64-.2-1.54-2.63.12-2.69h0Z"
          />
        </g>
        <g>
          <path
            opacity=".08"
            d="m143.26,170.03s-2.22-15.87-19.38-15.87-19.38,15.87-19.38,15.87h38.77Z"
          />
          <path
            fill="#fff"
            d="m106.19,172.5c0,8.59,8,15.55,17.87,15.55s17.87-6.96,17.87-15.55"
          />
          <path
            :fill="data.color"
            d="m136.54,170.94v.73c0,6.74-5.19,12.24-11.62,12.24s-11.62-5.5-11.62-12.24v-.73h23.23Z"
          />
          <path
            d="m131.14,173.66v.41c0,3.63-2.8,6.53-6.22,6.53s-6.22-2.9-6.22-6.53v-.41h12.45Z"
          />
          <g fill="none" opacity=".3">
            <path
              d="m131.14,173.66v.41c0,3.63-2.8,6.53-6.22,6.53s-6.22-2.9-6.22-6.53v-.41h12.45Z"
            />
          </g>
          <path
            d="m143.26,170.03c-13.35-.37-27.5-.29-40.85,0-1.72.07-1.73,2.63,0,2.7,11.83.89,23.89,1.04,35.74.43,1.74-.12,3.48-.24,5.22-.44,1.64-.2,1.54-2.63-.12-2.69h0Z"
          />
        </g>
        <ellipse fill="#fff" cx="202.78" cy="178.7" rx="2.83" ry="1.57" />
        <ellipse fill="#fff" cx="131.11" cy="178.7" rx="2.83" ry="1.57" />
      </g>
    </g>
    <g
      id="Eye_type_A-10-3-1-23"
      v-if="data.value === 'type-23' && data.position === 'm'"
    >
      <g>
        <path
          :fill="data.color"
          d="m211.95,180.18c-9.54-5.19-19.55-7.63-30.22-5.19-1.45.34-2.9.75-4.4,1.3-.89.37-1.77-.75-1.22-1.53,4.22-6.08,12.66-7.26,19.45-6.05,6.83,1.16,13.13,4.78,17.63,9.91.74.83-.28,2.1-1.24,1.55h0Z"
        />
        <g fill="none" opacity=".1">
          <path
            :fill="data.color"
            d="m200.85,162.16s.06-.04.09-.07c.2-.19-.78-2.85-5.34-4.38s-8.46.24-8.43.51c.04.27.28.47.56.43,5.07-.65,10.7,1.56,12.51,3.43.16.17.42.2.61.08Z"
          />
        </g>
        <path
          :fill="data.color"
          d="m106.81,178.63c7.8-8.94,22.26-13.79,33.15-7.59,1.11.72,5.45,3.83,3.63,5.15-.31.2-.68.21-1,.07-5.6-1.99-11.42-2.59-17.32-1.97-6.09.69-11.69,3.05-17.22,5.9-.96.55-1.99-.74-1.24-1.55h0Z"
        />
        <g fill="none" opacity=".1">
          <path
            :fill="data.color"
            d="m119.16,162.16s-.06-.04-.09-.07c-.2-.19.78-2.85,5.34-4.38,4.55-1.53,8.46.24,8.43.51-.04.27-.28.47-.56.43-5.07-.65-10.7,1.56-12.51,3.43-.16.17-.42.2-.61.08Z"
          />
        </g>
      </g>
    </g>
    <g
      id="Eye_type_A-10-3-1-22"
      v-if="data.value === 'type-22' && data.position === 'm'"
    >
      <g>
        <path
          :fill="data.color"
          d="m175.22,178.68c6.6-7.86,17.68-12.86,27.99-10.11,3.43,1.04,6.74,2.84,8.78,5.91.31.49.17,1.14-.31,1.45-.3.19-.64.21-.95.1-5.81-1.73-11.29-2.67-17.22-1.97-6.02.73-11.52,3.39-17.02,6.18-.97.56-2.01-.72-1.26-1.55h0Z"
        />
        <g fill="none" opacity=".08">
          <path
            :fill="data.color"
            d="m177.08,167.83s-.08,0-.12-.01c-.27-.07-.77-2.87,2.4-6.51s7.46-4.1,7.57-3.84c.11.25,0,.55-.26.66-4.73,2.01-8.49,6.79-9.11,9.33-.06.23-.26.38-.49.38Z"
          />
        </g>
        <path
          :fill="data.color"
          d="m143.66,178.68c-6.6-7.86-17.68-12.86-27.99-10.11-3.43,1.04-6.74,2.84-8.78,5.91-.31.49-.17,1.14.31,1.45.3.19.64.21.95.1,5.81-1.73,11.29-2.67,17.22-1.97,6.02.73,11.52,3.39,17.02,6.18.97.56,2.01-.72,1.26-1.55h0Z"
        />
        <g fill="none" opacity=".08">
          <path
            :fill="data.color"
            d="m141.8,167.83s.08,0,.12-.01c.27-.07.77-2.87-2.4-6.51s-7.46-4.1-7.57-3.84c-.11.25,0,.55.26.66,4.73,2.01,8.49,6.79,9.11,9.33.06.23.26.38.49.38Z"
          />
        </g>
      </g>
    </g>
    <g
      id="Eye_type_A-10-3-1-2"
      v-if="data.value === 'type-15' && data.position === 'm'"
    >
      <g>
        <g>
          <path
            d="M188.59,159.82l-11.46,9.1s-.44,8.01,8.51,12.41c8.95,4.4,21.87,2.24,29.51-5.6,0,0-10.55-16.5-26.57-15.92Z"
            fill="#fff"
          />
          <ellipse
            cx="192.54"
            cy="171.84"
            rx="11.03"
            ry="10.46"
            transform="translate(17.06 361.07) rotate(-88.91)"
            fill="#040403"
          />
          <ellipse
            cx="192.54"
            cy="171.84"
            rx="9.43"
            ry="8.95"
            transform="translate(17.06 361.07) rotate(-88.91)"
            :fill="data.color"
          />
          <ellipse
            cx="192.54"
            cy="171.84"
            rx="9.43"
            ry="8.95"
            transform="translate(17.06 361.07) rotate(-88.91)"
            :fill="data.color"
            opacity=".3"
          />
          <ellipse
            cx="192.09"
            cy="171.66"
            rx="3.81"
            ry="3.34"
            transform="translate(16.8 360.45) rotate(-88.91)"
            fill="#232120"
          />
          <ellipse
            cx="183.87"
            cy="170.68"
            rx="1.79"
            ry="2.39"
            transform="translate(9.71 351.26) rotate(-88.91)"
            fill="#fff"
          />
          <path
            d="M177.58,165.17s-2.3,2.39-1.41,3.88,2.73,1.32,5.03-.35,5.88-6.39,13.28-5.36c7.4,1.03,13.56,7.25,17.17,10.92,3.45,3.52,5.54,3.33,6.54,2.74s-1.91-2.38-5.53-7.26c-3.62-4.89-9-9.4-16.04-10.58s-13.46,.11-19.04,6.02Z"
            fill="#040403"
          />
        </g>
        <g>
          <path
            d="M130.95,159.82l11.46,9.1s.44,8.01-8.51,12.41c-8.95,4.4-21.87,2.24-29.51-5.6,0,0,10.55-16.5,26.57-15.92Z"
            fill="#fff"
          />
          <ellipse
            cx="126.98"
            cy="171.84"
            rx="10.46"
            ry="11.03"
            transform="translate(-3.25 2.45) rotate(-1.09)"
            fill="#040403"
          />
          <ellipse
            cx="126.98"
            cy="171.84"
            rx="8.95"
            ry="9.43"
            transform="translate(-3.25 2.45) rotate(-1.09)"
            :fill="data.color"
          />
          <ellipse
            cx="126.98"
            cy="171.84"
            rx="8.95"
            ry="9.43"
            transform="translate(-3.25 2.45) rotate(-1.09)"
            :fill="data.color"
            opacity=".3"
          />
          <ellipse
            cx="127.44"
            cy="171.66"
            rx="3.34"
            ry="3.81"
            transform="translate(-3.25 2.46) rotate(-1.09)"
            fill="#232120"
          />
          <ellipse
            cx="117.8"
            cy="170.68"
            rx="2.39"
            ry="1.79"
            transform="translate(-3.23 2.28) rotate(-1.09)"
            fill="#fff"
          />
          <path
            d="M141.96,165.17s2.3,2.39,1.41,3.88c-.89,1.48-2.73,1.32-5.03-.35s-5.88-6.39-13.28-5.36c-7.4,1.03-13.56,7.25-17.17,10.92s-5.54,3.33-6.54,2.74,1.91-2.38,5.53-7.26c3.62-4.89,9-9.4,16.04-10.58s13.46,.11,19.04,6.02Z"
            fill="#040403"
          />
        </g>
      </g>
    </g>
    <g
      id="Eye_type_A-10-3-2-2"
      v-if="data.value === 'type-16' && data.position === 'm'"
    >
      <g>
        <g>
          <path
            d="M191.56,160.29c-10.94,2.03-13.2,7.57-13.2,7.57,0,0-3.06,12.25,9.96,16.24,11.52,3.53,22.38,.09,25.56-6.25,2.32-4.94-11.39-19.59-22.32-17.56Z"
            fill="#fff"
          />
          <ellipse
            cx="193.5"
            cy="173.01"
            rx="11.4"
            ry="11.55"
            transform="translate(-52.36 256.22) rotate(-60.5)"
            fill="#28201e"
          />
          <ellipse
            cx="193.5"
            cy="173.01"
            rx="9.77"
            ry="9.9"
            transform="translate(-52.36 256.22) rotate(-60.5)"
            :fill="data.color"
          />
          <ellipse
            cx="193.5"
            cy="173.01"
            rx="9.77"
            ry="9.9"
            transform="translate(-52.36 256.22) rotate(-60.5)"
            :fill="data.color"
            opacity=".3"
          />
          <ellipse
            cx="192.65"
            cy="173.04"
            rx="4.24"
            ry="5.07"
            transform="translate(-1.71 1.92) rotate(-.57)"
            fill="#28201e"
          />
          <ellipse
            cx="183.1"
            cy="172.38"
            rx="2.31"
            ry="2.78"
            transform="translate(1.6 346.43) rotate(-87.07)"
            fill="#fff"
          />
          <path
            d="M176.53,167.31s-.48-1.42,2.67-4.56c3.15-3.15,8.08-5.39,12.22-5.61,4.51-.24,18.15,2.11,25.31,21.13,.72,1.92-1.68,2.86-3.04,.48-2.54-4.45-9.07-15.29-22.32-16.65-.05,0-.09,0-.13,0-.53,.11-4.17,.68-8.56,4.46,0,0-4.74,4.5-6.15,.75Z"
            fill="#28201e"
          />
          <path
            d="M211.28,170.32c5.39,2.37,9.18,1.07,9.18,1.07,0,0-2,3.42-6.42,2.79-3.42-.49-2.76-3.86-2.76-3.86Z"
            fill="#28201e"
          />
        </g>
        <g>
          <path
            d="M128.41,160.29c10.94,2.03,13.2,7.57,13.2,7.57,0,0,3.06,12.25-9.96,16.24-11.52,3.53-22.38,.09-25.56-6.25-2.32-4.94,11.39-19.59,22.32-17.56Z"
            fill="#fff"
          />
          <ellipse
            cx="126.43"
            cy="173.01"
            rx="11.55"
            ry="11.4"
            transform="translate(-68.8 84.69) rotate(-29.5)"
            fill="#28201e"
          />
          <ellipse
            cx="126.43"
            cy="173.01"
            rx="9.9"
            ry="9.77"
            transform="translate(-68.8 84.69) rotate(-29.5)"
            :fill="data.color"
          />
          <ellipse
            cx="126.43"
            cy="173.01"
            rx="9.9"
            ry="9.77"
            transform="translate(-68.8 84.69) rotate(-29.5)"
            :fill="data.color"
            opacity=".3"
          />
          <ellipse
            cx="127.28"
            cy="173.04"
            rx="5.07"
            ry="4.24"
            transform="translate(-47.02 298.59) rotate(-89.43)"
            fill="#28201e"
          />
          <ellipse
            cx="116.32"
            cy="171.5"
            rx="2.78"
            ry="2.31"
            transform="translate(-8.61 6.16) rotate(-2.93)"
            fill="#fff"
          />
          <path
            d="M143.43,167.31s.48-1.42-2.67-4.56-8.08-5.39-12.22-5.61c-4.51-.24-18.15,2.11-25.31,21.13-.72,1.92,1.68,2.86,3.04,.48,2.54-4.45,9.07-15.29,22.32-16.65,.05,0,.09,0,.13,0,.53,.11,4.17,.68,8.56,4.46,0,0,4.74,4.5,6.15,.75Z"
            fill="#28201e"
          />
          <path
            d="M108.69,170.32c-5.39,2.37-9.18,1.07-9.18,1.07,0,0,2,3.42,6.42,2.79,3.42-.49,2.76-3.86,2.76-3.86Z"
            fill="#28201e"
          />
        </g>
      </g>
    </g>
    <g
      id="Eye_type_A-10-3-3-2"
      v-if="data.value === 'type-17' && data.position === 'm'"
    >
      <g>
        <g>
          <path
            d="M128.65,160.25c10.97,1.86,13.31,7.36,13.31,7.36,0,0,3.36,11.69-9.6,15.88-11.46,3.71-22.7,1.01-25.98-5.28-2.4-4.9,11.3-19.82,22.26-17.96Z"
            fill="#fff"
          />
          <ellipse
            cx="126.64"
            cy="172.85"
            rx="10.97"
            ry="11.22"
            :fill="data.color"
          />
          <ellipse
            cx="126.64"
            cy="172.85"
            rx="10.97"
            ry="11.22"
            :fill="data.color"
            opacity=".3"
          />
          <path
            d="M126.64,184.57c-6.33,0-11.47-5.26-11.47-11.72s5.15-11.72,11.47-11.72,11.47,5.26,11.47,11.72-5.15,11.72-11.47,11.72Zm0-22.43c-5.77,0-10.47,4.81-10.47,10.72s4.7,10.72,10.47,10.72,10.47-4.81,10.47-10.72-4.7-10.72-10.47-10.72Z"
          />
          <ellipse cx="126.64" cy="172.85" rx="8.04" ry="8.15" />
          <ellipse cx="120.61" cy="171.8" rx="3.02" ry="3.09" fill="#fff" />
          <path
            d="M131.58,176.49c0-1.37,1.09-2.49,2.43-2.49s2.43,1.11,2.43,2.49-1.09,2.49-2.43,2.49-2.43-1.11-2.43-2.49Z"
            fill="#fff"
          />
          <path
            d="M121.29,158.66s-10.54,2.21-20.63,11.88c0,0,7.26-6.05,15.99-9.41,8.73-3.35,4.64-2.47,4.64-2.47Z"
            fill="#4e484b"
          />
          <path
            d="M131.35,158.73c.67-.82,1.46-2.28,1.2-4.36,0,0-.42,2.4-2.93,3.97-1.22-.22-2.52-.32-3.92-.27-2.82,.1-5.49,.88-7.97,2.05-2.52-1.44-2.75-3.94-2.75-3.94-.48,2.61,.58,4.19,1.11,4.78-2.95,1.64-5.56,3.79-7.74,5.92-2.65-.2-4.29-2.53-4.29-2.53,.65,3.01,2.32,3.65,3.04,3.79-3.45,3.63-5.52,6.9-5.62,7.13,0,0,3.02,3.12,7.36,5.81l-1.66-1.55c-.27-.25-.33-.65-.15-.97,1.41-2.47,6.38-12.84,18.36-15.62,11.48-3.45,19.21,8.33,19.21,8.33,0,0-3.8-9.84-13.25-12.53Z"
            fill="#040403"
          />
        </g>
        <g>
          <path
            d="M191.49,160.25c-10.97,1.86-13.31,7.36-13.31,7.36,0,0-3.36,11.69,9.6,15.88,11.46,3.71,22.7,1.01,25.98-5.28,2.4-4.9-11.3-19.82-22.26-17.96Z"
            fill="#fff"
          />
          <ellipse
            cx="193.59"
            cy="172.85"
            rx="10.97"
            ry="11.22"
            :fill="data.color"
          />
          <ellipse
            cx="193.59"
            cy="172.85"
            rx="10.97"
            ry="11.22"
            :fill="data.color"
            opacity=".3"
          />
          <path
            d="M193.59,184.57c-6.33,0-11.47-5.26-11.47-11.72s5.15-11.72,11.47-11.72,11.47,5.26,11.47,11.72-5.15,11.72-11.47,11.72Zm0-22.43c-5.77,0-10.47,4.81-10.47,10.72s4.7,10.72,10.47,10.72,10.47-4.81,10.47-10.72-4.7-10.72-10.47-10.72Z"
          />
          <path
            d="M193.59,164.7c-4.43,0-8.04,3.66-8.04,8.15s3.61,8.15,8.04,8.15,8.04-3.66,8.04-8.15-3.61-8.15-8.04-8.15Z"
          />
          <ellipse cx="186.8" cy="171.8" rx="3.02" ry="3.09" fill="#fff" />
          <ellipse cx="200.2" cy="176.49" rx="2.43" ry="2.49" fill="#fff" />
          <path
            d="M198.86,158.66s10.54,2.21,20.63,11.88c0,0-7.26-6.05-15.99-9.41-8.73-3.35-4.64-2.47-4.64-2.47Z"
            fill="#4e484b"
          />
          <path
            d="M213.05,168.13c.72-.14,2.39-.78,3.04-3.79,0,0-1.64,2.33-4.29,2.53-2.18-2.13-4.79-4.27-7.74-5.92,.53-.6,1.59-2.17,1.11-4.78,0,0-.23,2.5-2.75,3.94-2.48-1.17-5.15-1.95-7.97-2.05-1.39-.05-2.7,.05-3.92,.27-2.52-1.56-2.93-3.97-2.93-3.97-.26,2.08,.53,3.54,1.2,4.36-9.46,2.69-13.25,12.53-13.25,12.53,0,0,7.73-11.78,19.21-8.33,11.98,2.78,16.96,13.15,18.36,15.62,.18,.32,.12,.72-.15,.97l-1.66,1.55c4.34-2.69,7.36-5.81,7.36-5.81-.1-.23-2.17-3.5-5.62-7.13Z"
            fill="#040403"
          />
        </g>
      </g>
    </g>
    <g
      id="Eye_type_A-10-3-4-2"
      v-if="data.value === 'type-18' && data.position === 'm'"
    >
      <g>
        <g>
          <path
            d="M190.68,159.84c-11.59-2.05-13.95,6.61-13.95,6.61,0,0-1.05,9.53,7.84,14.66s21.17,4.89,29.99-1.65c0,0,11.54-13.37-23.87-19.63Z"
            fill="#fff"
          />
          <ellipse
            cx="192.31"
            cy="171.96"
            rx="10.84"
            ry="11.08"
            :fill="data.color"
          />
          <g opacity=".3">
            <ellipse
              cx="192.31"
              cy="171.96"
              rx="10.84"
              ry="11.08"
              :fill="data.color"
            />
          </g>
          <path
            d="M192.31,162.38c5.15,0,9.34,4.3,9.34,9.58s-4.19,9.58-9.34,9.58-9.34-4.3-9.34-9.58,4.19-9.58,9.34-9.58m0-1.5c-5.99,0-10.84,4.96-10.84,11.08s4.85,11.08,10.84,11.08,10.84-4.96,10.84-11.08-4.85-11.08-10.84-11.08h0Z"
          />
          <ellipse cx="192.31" cy="171.96" rx="4.97" ry="5.08" fill="#040403" />
          <path
            d="M185.36,163.52c.92-.84,1.27-1.18,3.5-1.56,2.37-.4,4.14-.7,6.42-.2,.94,.2,1.8,.54,3.17,1.47,3.16,2.12,3.64,5.7,3.9,7.03,.33,1.66,.41,4.93,.5,4.28,.28-1.95-2.04-3.82-4.4-4.73-7.52-2.92-12.05-.36-12.52-.2-4.01,1.29-2.95,3.65-3.57,2.99-.37-.39-.03-2.94,1.16-5.7,1.12-2.58,1.6-3.14,1.84-3.36Z"
            fill="#040403"
          />
          <ellipse cx="196.85" cy="176.08" rx="2.2" ry="2.25" fill="#fff" />
          <ellipse cx="185.51" cy="167.68" rx="1.1" ry="1.13" fill="#686868" />
          <path
            d="M207.45,165.25c-13.35-3.34-24.58-2.97-24.58-2.97-1.76,.93-4.55,4.38-5.58,4.15s-.89-.94-.89-.94c0,0,2.25-3.7,3.1-4.68,1.08-1.25,2.4-1.61,2.4-1.61,0,0,15.45-.12,27.36,2.97,0,0,5.35,4.04,8.3,12.06,0,0,.68,1.97-.57,2.02-.87,.03-1.41-.81-2.17-2.39-1.24-3.34-7.36-8.61-7.36-8.61Z"
            fill="#030303"
          />
        </g>
        <g>
          <path
            d="M129.05,159.84c11.59-2.05,13.95,6.61,13.95,6.61,0,0,1.05,9.53-7.84,14.66-8.89,5.13-21.17,4.89-29.99-1.65,0,0-11.54-13.37,23.87-19.63Z"
            fill="#fff"
          />
          <ellipse
            cx="127.43"
            cy="171.93"
            rx="10.84"
            ry="11.08"
            :fill="data.color"
          />
          <g opacity=".3">
            <ellipse
              cx="127.43"
              cy="171.93"
              rx="10.84"
              ry="11.08"
              :fill="data.color"
            />
          </g>
          <path
            d="M127.43,162.35c5.15,0,9.34,4.3,9.34,9.58s-4.19,9.58-9.34,9.58-9.34-4.3-9.34-9.58,4.19-9.58,9.34-9.58m0-1.5c-5.99,0-10.84,4.96-10.84,11.08s4.85,11.08,10.84,11.08,10.84-4.96,10.84-11.08-4.85-11.08-10.84-11.08h0Z"
          />
          <ellipse cx="127.43" cy="171.93" rx="4.97" ry="5.08" fill="#040403" />
          <path
            d="M134.38,163.49c-.92-.84-1.27-1.18-3.5-1.56-2.37-.4-4.14-.7-6.42-.2-.94,.2-1.8,.54-3.17,1.47-3.16,2.12-3.64,5.7-3.9,7.03-.33,1.66-.41,4.93-.5,4.28-.28-1.95,2.04-3.82,4.4-4.73,7.52-2.92,12.05-.36,12.52-.2,4.01,1.29,2.95,3.65,3.57,2.99,.37-.39,.03-2.94-1.16-5.7-1.12-2.58-1.6-3.14-1.84-3.36Z"
            fill="#040403"
          />
          <ellipse cx="133.13" cy="176.05" rx="2.2" ry="2.25" fill="#fff" />
          <ellipse cx="121.78" cy="167.65" rx="1.1" ry="1.13" fill="#686868" />
          <path
            d="M112.29,165.25c13.35-3.34,24.58-2.97,24.58-2.97,1.76,.93,4.55,4.38,5.58,4.15s.89-.94,.89-.94c0,0-2.25-3.7-3.1-4.68-1.08-1.25-2.4-1.61-2.4-1.61,0,0-15.45-.12-27.36,2.97,0,0-5.35,4.04-8.3,12.06,0,0-.68,1.97,.57,2.02,.87,.03,1.41-.81,2.17-2.39,1.24-3.34,7.36-8.61,7.36-8.61Z"
            fill="#030303"
          />
        </g>
      </g>
    </g>
    <g
      id="Eye_type_A-10-3-5-2"
      v-if="data.value === 'type-19' && data.position === 'm'"
    >
      <g>
        <g>
          <path
            d="M191.5,160.46c-6.49-2.12-11.91,2.44-14.46,5.18-1.1,1.18-1.42,2.88-.88,4.4,1.07,3.01,3.7,8.02,9.8,11.1,9.17,4.63,21.03,5.28,29.77-3.26,0,0,8.28-6.82-24.24-17.42Z"
            fill="#fff"
          />
          <ellipse
            cx="192.35"
            cy="172.15"
            rx="10.85"
            ry="11.09"
            :fill="data.color"
          />
          <g opacity=".3">
            <ellipse
              cx="192.35"
              cy="172.15"
              rx="10.85"
              ry="11.09"
              :fill="data.color"
            />
          </g>
          <path
            d="M192.35,162.06c5.43,0,9.85,4.52,9.85,10.09s-4.42,10.09-9.85,10.09-9.85-4.52-9.85-10.09,4.42-10.09,9.85-10.09m0-1c-5.99,0-10.85,4.96-10.85,11.09s4.86,11.09,10.85,11.09,10.85-4.96,10.85-11.09-4.86-11.09-10.85-11.09h0Z"
          />
          <ellipse cx="192.35" cy="172.15" rx="4.98" ry="5.09" fill="#040403" />
          <path
            d="M185.56,163.65c.92-.84,1.52-1.29,3.11-1.75,2.31-.67,4.14-.7,6.43-.2,.94,.2,1.8,.54,3.17,1.47,3.16,2.12,3.64,5.71,3.9,7.03,.33,1.66,.41,4.94,.5,4.28,.28-1.95-2.04-3.82-4.4-4.74-7.53-2.92-12.06-.36-12.53-.2-4.01,1.29-2.95,3.65-3.57,2.99-.37-.39-.03-2.94,1.16-5.7,1.12-2.58,1.99-2.95,2.23-3.17Z"
            fill="#040403"
          />
          <ellipse cx="187.26" cy="165.57" rx="2.2" ry="1.78" fill="#727272" />
          <path
            d="M175.66,166.29s3.87-7.55,19.35-6.93c11.21,.83,24.28,13.66,24.8,14.62,0,0-1.93,.79-3.51,.63,0,0-8.87-9.46-21.48-12.06,0,0-8.1-2.3-16.88,3.75,0,0-2.28,.95-2.28,0Z"
            fill="#0e0d0a"
          />
          <path
            d="M182.9,179.22s1.83,1.52,3.71,1.87c2.44,.45,9.81,3.04,17.17,2.14,0,0,2.24-.38,3.49,.16,0,0-13.28,4.53-24.37-4.17Z"
            fill="#494949"
          />
        </g>
        <g>
          <path
            d="M128.37,160.46c6.49-2.12,11.91,2.44,14.46,5.18,1.1,1.18,1.42,2.88,.88,4.4-1.07,3.01-3.7,8.02-9.8,11.1-9.17,4.63-21.03,5.28-29.77-3.26,0,0-8.28-6.82,24.24-17.42Z"
            fill="#fff"
          />
          <ellipse
            cx="127.53"
            cy="172.15"
            rx="10.85"
            ry="11.09"
            :fill="data.color"
          />
          <g opacity=".3">
            <ellipse
              cx="127.53"
              cy="172.15"
              rx="10.85"
              ry="11.09"
              :fill="data.color"
            />
          </g>
          <path
            d="M127.53,162.06c5.43,0,9.85,4.52,9.85,10.09s-4.42,10.09-9.85,10.09-9.85-4.52-9.85-10.09,4.42-10.09,9.85-10.09m0-1c-5.99,0-10.85,4.96-10.85,11.09s4.86,11.09,10.85,11.09,10.85-4.96,10.85-11.09-4.86-11.09-10.85-11.09h0Z"
          />
          <ellipse cx="127.53" cy="172.15" rx="4.98" ry="5.09" fill="#040403" />
          <path
            d="M134.19,163.68c-1.49-.77-1.29-1.35-2.97-1.78-2.33-.6-4.14-.7-6.43-.2-.94,.2-1.8,.54-3.17,1.47-3.16,2.12-3.64,5.71-3.9,7.03-.33,1.66-.41,4.94-.5,4.28-.28-1.95,2.04-3.82,4.4-4.74,7.53-2.92,12.06-.36,12.53-.2,4.01,1.29,2.95,3.65,3.57,2.99,.37-.39,.03-2.94-1.16-5.7-1.12-2.58-2.08-2.99-2.37-3.14Z"
            fill="#040403"
          />
          <ellipse cx="123.84" cy="165.57" rx="2.2" ry="1.78" fill="#727272" />
          <path
            d="M144.21,166.29s-3.87-7.55-19.35-6.93c-11.21,.83-24.28,13.66-24.8,14.62,0,0,1.93,.79,3.51,.63,0,0,8.87-9.46,21.48-12.06,0,0,8.1-2.3,16.88,3.75,0,0,2.28,.95,2.28,0Z"
            fill="#0e0d0a"
          />
          <path
            d="M136.97,179.22s-1.83,1.52-3.71,1.87c-2.44,.45-9.81,3.04-17.17,2.14,0,0-2.24-.38-3.49,.16,0,0,13.28,4.53,24.37-4.17Z"
            fill="#494949"
          />
        </g>
      </g>
    </g>
    <g
      id="Eye_type_A-10-3-6-2"
      v-if="data.value === 'type-20' && data.position === 'm'"
    >
      <g>
        <g>
          <path
            d="M189.19,162.19c-12.18-1.33-13.7,4.86-13.7,4.86,0,0,.7,7.33,10.41,11.29,9.71,3.97,22.35,4.6,30-1.71,0,0,10.53-10.38-26.71-14.43Z"
            fill="#fff"
          />
          <g>
            <g>
              <path
                d="M200.86,165.87c-.95-1.4-2.28-2.51-3.84-3.16-2.46-.02-4.66,0-6.58,.08-1.49,.66-2.75,1.74-3.66,3.09-.94,1.41-1.5,3.11-1.5,4.95,0,4.83,3.84,8.76,8.55,8.76s8.55-3.93,8.55-8.76c0-1.84-.56-3.55-1.51-4.96Z"
                :fill="data.color"
              />
              <path
                d="M200.86,165.87c-.95-1.4-2.28-2.51-3.84-3.16-2.46-.02-4.66,0-6.58,.08-1.49,.66-2.75,1.74-3.66,3.09-.94,1.41-1.5,3.11-1.5,4.95,0,4.83,3.84,8.76,8.55,8.76s8.55-3.93,8.55-8.76c0-1.84-.56-3.55-1.51-4.96Z"
                :fill="data.color"
                opacity=".3"
              />
              <path
                d="M201.91,165.94c-.75-1.29-1.77-2.38-3-3.19-.65-.01-1.28-.02-1.9-.03,1.56,.65,2.9,1.75,3.84,3.16,.95,1.41,1.51,3.12,1.51,4.96,0,4.83-3.84,8.76-8.55,8.76s-8.55-3.93-8.55-8.76c0-1.83,.56-3.54,1.5-4.95,.91-1.35,2.17-2.43,3.66-3.09-.67,.02-1.31,.05-1.92,.09-1.15,.8-2.11,1.86-2.81,3.09-.82,1.43-1.3,3.09-1.3,4.87,0,5.32,4.22,9.63,9.42,9.63s9.42-4.31,9.42-9.63c0-1.79-.49-3.46-1.32-4.9Z"
                fill="#030302"
              />
            </g>
            <ellipse
              cx="193.82"
              cy="170.83"
              rx="4.32"
              ry="4.42"
              fill="#040403"
            />
            <ellipse cx="198.04" cy="174.37" rx="2.15" ry="1.73" fill="#888" />
          </g>
          <path
            d="M175.49,167.05s-2.49-1.05,5.13-5.36c.35-.2,.76-.31,1.18-.33,2.38-.12,11.22-.27,26.83,2.72,.9,.17,1.75,.54,2.47,1.07,1.78,1.33,5.27,4.23,8.04,8.43,0,0-4.37,5.29-7.8,5.8,0,0,5.13-3.07,4.74-6.35,0,0-5.81-4.44-10.34-6.21,0,0-14.86-3.22-24.61-2.42,0,0-2.57-.4-5.64,2.64Z"
            fill="#030302"
          />
        </g>
        <g>
          <path
            d="M130.67,162.19c12.18-1.33,13.7,4.86,13.7,4.86,0,0-.7,7.33-10.41,11.29-9.71,3.97-22.35,4.6-30-1.71,0,0-10.53-10.38,26.71-14.43Z"
            fill="#fff"
          />
          <g>
            <g>
              <path
                d="M133.35,165.87c-.95-1.4-2.28-2.51-3.84-3.16-2.46-.02-4.66,0-6.58,.08-1.49,.66-2.75,1.74-3.66,3.09-.94,1.41-1.5,3.11-1.5,4.95,0,4.83,3.84,8.76,8.55,8.76s8.55-3.93,8.55-8.76c0-1.84-.56-3.55-1.51-4.96Z"
                :fill="data.color"
              />
              <path
                d="M133.35,165.87c-.95-1.4-2.28-2.51-3.84-3.16-2.46-.02-4.66,0-6.58,.08-1.49,.66-2.75,1.74-3.66,3.09-.94,1.41-1.5,3.11-1.5,4.95,0,4.83,3.84,8.76,8.55,8.76s8.55-3.93,8.55-8.76c0-1.84-.56-3.55-1.51-4.96Z"
                :fill="data.color"
                opacity=".3"
              />
              <path
                d="M134.4,165.94c-.75-1.29-1.77-2.38-3-3.19-.65-.01-1.28-.02-1.9-.03,1.56,.65,2.9,1.75,3.84,3.16,.95,1.41,1.51,3.12,1.51,4.96,0,4.83-3.84,8.76-8.55,8.76s-8.55-3.93-8.55-8.76c0-1.83,.56-3.54,1.5-4.95,.91-1.35,2.17-2.43,3.66-3.09-.67,.02-1.31,.05-1.92,.09-1.15,.8-2.11,1.86-2.81,3.09-.82,1.43-1.3,3.09-1.3,4.87,0,5.32,4.22,9.63,9.42,9.63s9.42-4.31,9.42-9.63c0-1.79-.49-3.46-1.32-4.9Z"
                fill="#030302"
              />
            </g>
            <ellipse
              cx="126.31"
              cy="170.83"
              rx="4.32"
              ry="4.42"
              fill="#040403"
            />
            <ellipse cx="130.53" cy="174.37" rx="2.15" ry="1.73" fill="#888" />
          </g>
          <path
            d="M144.37,167.05s2.49-1.05-5.13-5.36c-.35-.2-.76-.31-1.18-.33-2.38-.12-11.22-.27-26.83,2.72-.9,.17-1.75,.54-2.47,1.07-1.78,1.33-5.27,4.23-8.04,8.43,0,0,4.37,5.29,7.8,5.8,0,0-5.13-3.07-4.74-6.35,0,0,5.81-4.44,10.34-6.21,0,0,14.86-3.22,24.61-2.42,0,0,2.57-.4,5.64,2.64Z"
            fill="#030302"
          />
        </g>
      </g>
    </g>
    <g
      id="Eye_type_A-10-3-7-2"
      v-if="data.value === 'type-21' && data.position === 'm'"
    >
      <g>
        <g>
          <path
            d="M188.6,163.22c-12.24-.53-13.24,4.28-13.24,4.28,0,0,1.31,5.6,11.3,8.26,9.99,2.66,22.64,2.64,29.73-2.52,0,0,9.63-8.4-27.8-10.02Z"
            fill="#fff"
          />
          <path
            d="M185.7,164.97s-.07,0-.11,0c-.06,.22-.14,.43-.18,.66-.11,.53-.18,1.08-.18,1.65,0,4.61,3.66,8.35,8.16,8.35s8.16-3.75,8.16-8.35c0-.55-.08-1.07-.18-1.59-3.93-.37-10.07-.83-15.66-.72Z"
            :fill="data.color"
          />
          <path
            d="M185.7,164.97s-.07,0-.11,0c-.06,.22-.14,.43-.18,.66-.11,.53-.18,1.08-.18,1.65,0,4.61,3.66,8.35,8.16,8.35s8.16-3.75,8.16-8.35c0-.55-.08-1.07-.18-1.59-3.93-.37-10.07-.83-15.66-.72Z"
            :fill="data.color"
            opacity=".3"
          />
          <path
            d="M201.36,165.69c.1,.52,.18,1.04,.18,1.59,0,4.61-3.66,8.35-8.16,8.35s-8.16-3.75-8.16-8.35c0-.57,.07-1.11,.18-1.65,.04-.23,.12-.44,.18-.66-.25,0-.5,.01-.75,.02-.04,0-.08,0-.12,0-.06,.23-.13,.46-.17,.71-.09,.51-.15,1.03-.15,1.57,0,5.07,4.02,9.18,8.98,9.18s8.98-4.11,8.98-9.18c0-.52-.06-1.02-.15-1.51-.2-.02-.4-.04-.62-.06-.07,0-.16-.01-.24-.02Z"
            fill="#030302"
          />
          <ellipse cx="193.38" cy="167.28" rx="4.12" ry="4.21" fill="#040403" />
          <ellipse cx="196.37" cy="170.78" rx="2.44" ry="1.04" fill="#fff" />
          <path
            d="M210.67,164.61c-.75-.38-1.63-.63-2.54-.72-2.28-.24-4.4-.43-6.39-.59-.32-.03-.64-.05-.95-.07-6.1-.46-10.79-.57-14.11-.55-.34,0-.65,0-.96,.01-2.23,.04-3.75,.13-4.54,.19-.42,.03-.81,.14-1.15,.3-7.23,3.62-4.66,4.33-4.66,4.33,2.8-2.46,5.4-2.25,5.4-2.25,1.28-.13,2.66-.22,4.08-.26,.29,0,.57-.02,.86-.02,5.69-.11,11.97,.36,15.89,.74,.3,.03,.58,.06,.85,.08,1.87,.19,3.02,.33,3.02,.33,4.67,1.18,10.81,4.36,10.81,4.36,.66,2.5-4.19,5.07-4.19,5.07,3.38-.53,7.29-4.77,7.29-4.77-3.11-3.12-6.82-5.21-8.71-6.16Z"
            fill="#030302"
          />
        </g>
        <g>
          <path
            d="M131.28,163.22c12.24-.53,13.24,4.28,13.24,4.28,0,0-1.31,5.6-11.3,8.26-9.99,2.66-22.64,2.64-29.73-2.52,0,0-9.63-8.4,27.8-10.02Z"
            fill="#fff"
          />
          <path
            d="M134.42,164.94s.07,0,.11,0c.06,.22,.14,.43,.18,.66,.11,.53,.18,1.08,.18,1.65,0,4.61-3.66,8.35-8.16,8.35-4.5,0-8.16-3.75-8.16-8.35,0-.55,.08-1.07,.18-1.59,3.93-.37,10.07-.83,15.66-.72Z"
            :fill="data.color"
          />
          <path
            d="M134.42,164.94s.07,0,.11,0c.06,.22,.14,.43,.18,.66,.11,.53,.18,1.08,.18,1.65,0,4.61-3.66,8.35-8.16,8.35-4.5,0-8.16-3.75-8.16-8.35,0-.55,.08-1.07,.18-1.59,3.93-.37,10.07-.83,15.66-.72Z"
            :fill="data.color"
            opacity=".3"
          />
          <path
            d="M118.76,165.66c-.1,.52-.18,1.04-.18,1.59,0,4.61,3.66,8.35,8.16,8.35,4.5,0,8.16-3.75,8.16-8.35,0-.57-.07-1.11-.18-1.65-.04-.23-.12-.44-.18-.66,.25,0,.5,.01,.75,.02,.04,0,.08,0,.12,0,.06,.23,.13,.46,.17,.71,.09,.51,.15,1.03,.15,1.57,0,5.07-4.02,9.18-8.98,9.18s-8.98-4.11-8.98-9.18c0-.52,.06-1.02,.15-1.51,.2-.02,.4-.04,.62-.06,.07,0,.16-.01,.24-.02Z"
            fill="#030302"
          />
          <ellipse cx="126.74" cy="167.25" rx="4.12" ry="4.21" fill="#040403" />
          <path
            d="M109.22,164.61c.75-.38,1.63-.63,2.54-.72,2.28-.24,4.4-.43,6.39-.59,.32-.03,.64-.05,.95-.07,6.1-.46,10.79-.57,14.11-.55,.34,0,.65,0,.96,.01,2.23,.04,3.75,.13,4.54,.19,.42,.03,.81,.14,1.15,.3,7.23,3.62,4.66,4.33,4.66,4.33-2.8-2.46-5.4-2.25-5.4-2.25-1.28-.13-2.66-.22-4.08-.26-.29,0-.57-.02-.86-.02-5.69-.11-11.97,.36-15.89,.74-.3,.03-.58,.06-.85,.08-1.87,.19-3.02,.33-3.02,.33-4.67,1.18-10.81,4.36-10.81,4.36-.66,2.5,4.19,5.07,4.19,5.07-3.38-.53-7.29-4.77-7.29-4.77,3.11-3.12,6.82-5.21,8.71-6.16Z"
            fill="#030302"
          />
          <ellipse cx="129.92" cy="170.78" rx="2.44" ry="1.04" fill="#fff" />
        </g>
      </g>
    </g>
    <g
      id="Eye_type_A-10-2-1-2"
      v-if="data.value === 'type-1' && data.position === 'm'"
    >
      <g id="_-160">
        <g>
          <path
            d="M186.92,161.27l-9.95,10.73s.88,7.47,10.4,10.47c9.51,3,21.84-.57,28.22-9.46,0,0-12.91-14.72-28.66-11.74Z"
            fill="#fff"
          />
          <g>
            <ellipse
              cx="192.54"
              cy="171.84"
              rx="11.03"
              ry="10.46"
              transform="translate(17.06 361.07) rotate(-88.91)"
              fill="#040403"
            />
            <ellipse
              cx="192.54"
              cy="171.84"
              rx="9.43"
              ry="8.95"
              transform="translate(17.06 361.07) rotate(-88.91)"
              :fill="data.color"
            />
            <ellipse
              cx="192.54"
              cy="171.84"
              rx="9.43"
              ry="8.95"
              transform="translate(17.06 361.07) rotate(-88.91)"
              :fill="data.color"
              opacity=".3"
            />
            <ellipse
              cx="192.09"
              cy="171.66"
              rx="3.81"
              ry="3.34"
              transform="translate(16.8 360.45) rotate(-88.91)"
              fill="#232120"
            />
          </g>
          <ellipse
            cx="183.87"
            cy="170.68"
            rx="1.79"
            ry="2.39"
            transform="translate(9.71 351.26) rotate(-88.91)"
            fill="#fff"
          />
          <path
            d="M176.85,168.22s-1.92,2.71-.81,4.04,2.89,.89,4.92-1.1c2.02-1.99,4.85-7.2,12.33-7.3s14.5,5.12,18.62,8.21,5.98,2.45,6.88,1.72-2.25-2.06-6.56-6.35c-4.32-4.29-10.31-7.93-17.45-8.05s-13.29,2.14-17.92,8.82Z"
            fill="#040403"
          />
        </g>
        <g>
          <path
            d="M132.52,161.49l10.3,10.46s-.83,7.3-10.54,10.25c-9.71,2.95-21.99,.37-28.49-8.73,0,0,12.57-14.86,28.73-11.97Z"
            fill="#fff"
          />
          <g>
            <ellipse
              cx="126.98"
              cy="171.84"
              rx="10.46"
              ry="11.03"
              transform="translate(-3.25 2.45) rotate(-1.09)"
              fill="#040403"
            />
            <ellipse
              cx="126.98"
              cy="171.84"
              rx="8.95"
              ry="9.43"
              transform="translate(-3.25 2.45) rotate(-1.09)"
              :fill="data.color"
            />
            <ellipse
              cx="126.98"
              cy="171.84"
              rx="8.95"
              ry="9.43"
              transform="translate(-3.25 2.45) rotate(-1.09)"
              :fill="data.color"
              opacity=".3"
            />
            <ellipse
              cx="127.44"
              cy="171.66"
              rx="3.34"
              ry="3.81"
              transform="translate(-3.25 2.46) rotate(-1.09)"
              fill="#232120"
            />
          </g>
          <ellipse
            cx="117.8"
            cy="170.68"
            rx="2.39"
            ry="1.79"
            transform="translate(-3.23 2.28) rotate(-1.09)"
            fill="#fff"
          />
          <path
            d="M142.91,168.26s1.99,2.65,.87,3.95c-1.12,1.3-2.95,.88-5.04-1.06s-5.04-7.02-12.69-7.1c-7.65-.08-14.79,5.03-18.98,8.05s-6.1,2.41-7.03,1.69,2.28-2.02,6.66-6.21c4.38-4.19,10.48-7.77,17.79-7.89s13.63,2.06,18.43,8.58Z"
            fill="#040403"
          />
        </g>
      </g>
    </g>
    <g
      id="Eye_type_A-10-2-2-2"
      v-if="data.value === 'type-2' && data.position === 'm'"
    >
      <g>
        <g>
          <path
            d="M189.91,161.41c-10.5,3.67-11.9,9.48-11.9,9.48,0,0-1.36,12.09,12.11,14.05,11.92,1.74,22.33-2.81,24.51-9.56,1.54-5.23-14.23-17.64-24.73-13.97Z"
            fill="#fff"
          />
          <g>
            <ellipse
              cx="193.5"
              cy="173.01"
              rx="11.4"
              ry="11.55"
              transform="translate(-52.36 256.22) rotate(-60.5)"
              fill="#28201e"
            />
            <ellipse
              cx="193.5"
              cy="173.01"
              rx="9.77"
              ry="9.9"
              transform="translate(-52.36 256.22) rotate(-60.5)"
              :fill="data.color"
            />
            <ellipse
              cx="193.5"
              cy="173.01"
              rx="9.77"
              ry="9.9"
              transform="translate(-52.36 256.22) rotate(-60.5)"
              :fill="data.color"
              opacity=".3"
            />
            <ellipse
              cx="192.65"
              cy="173.04"
              rx="4.24"
              ry="5.07"
              transform="translate(-1.71 1.92) rotate(-.57)"
              fill="#28201e"
            />
            <ellipse
              cx="183.1"
              cy="172.38"
              rx="2.31"
              ry="2.78"
              transform="translate(1.6 346.43) rotate(-87.07)"
              fill="#fff"
            />
          </g>
          <path
            d="M176.12,170.63s-.69-1.33,1.95-4.91,7.17-6.55,11.23-7.4c4.42-.92,18.26-.66,28.22,17.05,1,1.79-1.23,3.08-2.93,.94-3.19-4.02-11.48-14.4-24.82-13.69,0,0-3.9,1.3-7.68,6.35,0,0-4.01,5.16-5.97,1.67Z"
            fill="#28201e"
          />
          <path
            d="M210.92,168.34c5.69,1.53,9.24-.33,9.24-.33,0,0-1.46,3.68-5.92,3.73-3.46,.03-3.31-3.39-3.31-3.39Z"
            fill="#28201e"
          />
        </g>
        <g>
          <path
            d="M130.02,161.41c10.5,3.67,11.9,9.48,11.9,9.48,0,0,1.36,12.09-12.11,14.05-11.92,1.74-22.33-2.81-24.51-9.56-1.54-5.23,14.23-17.64,24.73-13.97Z"
            fill="#fff"
          />
          <g>
            <ellipse
              cx="126.43"
              cy="173.01"
              rx="11.55"
              ry="11.4"
              transform="translate(-68.8 84.69) rotate(-29.5)"
              fill="#28201e"
            />
            <ellipse
              cx="126.43"
              cy="173.01"
              rx="9.9"
              ry="9.77"
              transform="translate(-68.8 84.69) rotate(-29.5)"
              :fill="data.color"
            />
            <ellipse
              cx="126.43"
              cy="173.01"
              rx="9.9"
              ry="9.77"
              transform="translate(-68.8 84.69) rotate(-29.5)"
              :fill="data.color"
              opacity=".3"
            />
            <ellipse
              cx="127.28"
              cy="173.04"
              rx="5.07"
              ry="4.24"
              transform="translate(-47.02 298.59) rotate(-89.43)"
              fill="#28201e"
            />
            <ellipse
              cx="116.32"
              cy="171.5"
              rx="2.78"
              ry="2.31"
              transform="translate(-8.61 6.16) rotate(-2.93)"
              fill="#fff"
            />
          </g>
          <g>
            <path
              d="M143.81,170.63s.69-1.33-1.95-4.91-7.17-6.55-11.23-7.4c-4.42-.92-18.26-.66-28.22,17.05-1,1.79,1.23,3.08,2.93,.94,3.19-4.02,11.48-14.4,24.82-13.69,0,0,3.9,1.3,7.68,6.35,0,0,4.01,5.16,5.97,1.67Z"
              fill="#28201e"
            />
            <path
              d="M109,168.34c-5.69,1.53-9.24-.33-9.24-.33,0,0,1.46,3.68,5.92,3.73,3.46,.03,3.31-3.39,3.31-3.39Z"
              fill="#28201e"
            />
          </g>
        </g>
      </g>
    </g>
    <g
      id="Eye_type_A-10-2-3-2"
      v-if="data.value === 'type-3' && data.position === 'm'"
    >
      <g>
        <g>
          <path
            d="M130.07,161.23c10.5,3.67,11.9,9.48,11.9,9.48,0,0,1.36,12.09-12.11,14.05-11.92,1.74-22.07-2.73-24.82-9.57-1.54-5.23,14.53-17.63,25.03-13.96Z"
            fill="#fff"
          />
          <ellipse
            cx="126.64"
            cy="172.85"
            rx="10.97"
            ry="11.22"
            :fill="data.color"
          />
          <g opacity=".3">
            <ellipse
              cx="126.64"
              cy="172.85"
              rx="10.97"
              ry="11.22"
              :fill="data.color"
            />
          </g>
          <path
            d="M115.17,172.85c0-6.46,5.15-11.72,11.47-11.72,6.33,0,11.47,5.26,11.47,11.72s-5.15,11.72-11.47,11.72c-6.33,0-11.47-5.26-11.47-11.72Zm1,0c0,5.91,4.7,10.72,10.47,10.72,5.77,0,10.47-4.81,10.47-10.72s-4.7-10.72-10.47-10.72c-5.77,0-10.47,4.81-10.47,10.72Z"
          />
          <path
            d="M118.61,172.85c0,4.49,3.61,8.15,8.04,8.15,4.43,0,8.04-3.66,8.04-8.15s-3.61-8.15-8.04-8.15c-4.43,0-8.04,3.66-8.04,8.15Z"
          />
          <g>
            <path
              d="M117.6,171.8c0-1.71,1.35-3.09,3.02-3.09s3.02,1.38,3.02,3.09-1.35,3.09-3.02,3.09-3.02-1.38-3.02-3.09Z"
              fill="#fff"
            />
            <ellipse cx="134.02" cy="176.49" rx="2.43" ry="2.49" fill="#fff" />
          </g>
          <path
            d="M123.31,158.62s-10.76,.41-22.32,8.27c0,0,8.17-4.76,17.33-6.6s4.99-1.66,4.99-1.66Z"
            fill="#4e484b"
          />
          <path
            d="M107.74,165.59c-.69-.26-2.23-1.17-2.37-4.24,0,0,1.23,2.57,3.81,3.21,2.5-1.74,5.44-3.41,8.62-4.54-.42-.68-1.2-2.4-.29-4.9,0,0-.19,2.5,2.05,4.35,2.64-.74,5.4-1.06,8.2-.69,1.38,.18,2.65,.5,3.82,.92,2.74-1.12,3.56-3.42,3.56-3.42-.09,2.1-1.11,3.4-1.91,4.1,8.87,4.23,10.97,14.57,10.97,14.57,0,0-5.66-12.9-17.55-11.42-10.97,1.17-18.91,10.13-20.71,12.34-.23,.28-.24,.69-.01,.98l1.37,1.81c-3.83-3.38-6.29-6.95-6.29-6.95,.13-.21,2.72-3.09,6.73-6.09Z"
            fill="#040403"
          />
        </g>
        <g>
          <path
            d="M190.16,161.23c-10.5,3.67-11.9,9.48-11.9,9.48,0,0-1.36,12.09,12.11,14.05,11.92,1.74,22.07-2.73,24.82-9.57,1.54-5.23-14.53-17.63-25.03-13.96Z"
            fill="#fff"
          />
          <ellipse
            cx="193.59"
            cy="172.85"
            rx="10.97"
            ry="11.22"
            :fill="data.color"
          />
          <g opacity=".3">
            <ellipse
              cx="193.59"
              cy="172.85"
              rx="10.97"
              ry="11.22"
              :fill="data.color"
            />
          </g>
          <path
            d="M193.59,184.57c-6.33,0-11.47-5.26-11.47-11.72s5.15-11.72,11.47-11.72,11.47,5.26,11.47,11.72-5.15,11.72-11.47,11.72Zm0-22.43c-5.77,0-10.47,4.81-10.47,10.72s4.7,10.72,10.47,10.72,10.47-4.81,10.47-10.72-4.7-10.72-10.47-10.72Z"
          />
          <path
            d="M193.59,164.7c-4.43,0-8.04,3.66-8.04,8.15s3.61,8.15,8.04,8.15,8.04-3.66,8.04-8.15-3.61-8.15-8.04-8.15Z"
          />
          <ellipse cx="186.8" cy="171.8" rx="3.02" ry="3.09" fill="#fff" />
          <ellipse cx="200.2" cy="176.49" rx="2.43" ry="2.49" fill="#fff" />
          <path
            d="M196.92,158.62s10.76,.41,22.32,8.27c0,0-8.17-4.76-17.33-6.6s-4.99-1.66-4.99-1.66Z"
            fill="#4e484b"
          />
          <path
            d="M212.49,165.59c.69-.26,2.23-1.17,2.37-4.24,0,0-1.23,2.57-3.81,3.21-2.5-1.74-5.44-3.41-8.62-4.54,.42-.68,1.2-2.4,.29-4.9,0,0,.19,2.5-2.05,4.35-2.64-.74-5.4-1.06-8.2-.69-1.38,.18-2.65,.5-3.82,.92-2.74-1.12-3.56-3.42-3.56-3.42,.09,2.1,1.11,3.4,1.91,4.1-8.87,4.23-10.97,14.57-10.97,14.57,0,0,5.66-12.9,17.55-11.42,10.97,1.17,18.91,10.13,20.71,12.34,.23,.28,.24,.69,.01,.98l-1.37,1.81c3.83-3.38,6.29-6.95,6.29-6.95-.13-.21-2.72-3.09-6.73-6.09Z"
            fill="#040403"
          />
        </g>
      </g>
    </g>
    <g
      id="Eye_type_A-10-2-4-2"
      v-if="data.value === 'type-4' && data.position === 'm'"
    >
      <g>
        <g>
          <g>
            <g>
              <path
                d="M188.4,161.28c-11.76,.28-12.37,9.23-12.37,9.23,0,0,1.56,8.7,11.29,11.98s21.84,2.09,28.36-6.69c0,0,8.68-15.39-27.28-14.53Z"
                fill="#fff"
              />
              <g>
                <g>
                  <ellipse
                    cx="192.31"
                    cy="171.96"
                    rx="10.84"
                    ry="11.08"
                    :fill="data.color"
                  />
                  <ellipse
                    cx="192.31"
                    cy="171.96"
                    rx="10.84"
                    ry="11.08"
                    :fill="data.color"
                    opacity=".3"
                  />
                  <path
                    d="M192.31,162.38c5.15,0,9.34,4.3,9.34,9.58s-4.19,9.58-9.34,9.58-9.34-4.3-9.34-9.58,4.19-9.58,9.34-9.58m0-1.5c-5.99,0-10.84,4.96-10.84,11.08s4.85,11.08,10.84,11.08,10.84-4.96,10.84-11.08-4.85-11.08-10.84-11.08h0Z"
                  />
                </g>
                <ellipse
                  cx="192.31"
                  cy="171.96"
                  rx="4.97"
                  ry="5.08"
                  fill="#040403"
                />
              </g>
            </g>
            <path
              d="M185.36,163.52c.92-.84,1.27-1.18,3.5-1.56,2.37-.4,4.14-.7,6.42-.2,.94,.2,1.8,.54,3.17,1.47,3.16,2.12,3.64,5.7,3.9,7.03,.33,1.66,.41,4.93,.5,4.28,.28-1.95-2.04-3.82-4.4-4.73-7.52-2.92-12.05-.36-12.52-.2-4.01,1.29-2.95,3.65-3.57,2.99-.37-.39-.03-2.94,1.16-5.7,1.12-2.58,1.6-3.14,1.84-3.36Z"
              fill="#040403"
            />
            <ellipse cx="196.85" cy="176.08" rx="2.2" ry="2.25" fill="#fff" />
            <ellipse
              cx="185.51"
              cy="167.68"
              rx="1.1"
              ry="1.13"
              fill="#686868"
            />
          </g>
          <path
            d="M205.9,163.28c-13.75-.64-24.68,1.94-24.68,1.94-1.55,1.26-3.59,5.19-4.65,5.17s-1.06-.75-1.06-.75c0,0,1.48-4.08,2.12-5.2,.81-1.43,2.03-2.05,2.03-2.05,0,0,15.12-3.17,27.41-2.49,0,0,6.04,2.9,10.52,10.19,0,0,1.06,1.8-.16,2.1-.85,.2-1.55-.52-2.6-1.92-1.87-3.03-8.92-6.98-8.92-6.98Z"
            fill="#030303"
          />
        </g>
        <g>
          <g>
            <g>
              <path
                d="M131.34,161.26c11.76,.28,12.37,9.23,12.37,9.23,0,0-1.56,8.7-11.29,11.98-9.73,3.28-21.84,2.09-28.36-6.69,0,0-8.68-15.39,27.28-14.53Z"
                fill="#fff"
              />
              <g>
                <g>
                  <ellipse
                    cx="127.43"
                    cy="171.93"
                    rx="10.84"
                    ry="11.08"
                    :fill="data.color"
                  />
                  <ellipse
                    cx="127.43"
                    cy="171.93"
                    rx="10.84"
                    ry="11.08"
                    :fill="data.color"
                    opacity=".3"
                  />
                  <path
                    d="M127.43,162.35c5.15,0,9.34,4.3,9.34,9.58s-4.19,9.58-9.34,9.58-9.34-4.3-9.34-9.58,4.19-9.58,9.34-9.58m0-1.5c-5.99,0-10.84,4.96-10.84,11.08s4.85,11.08,10.84,11.08,10.84-4.96,10.84-11.08-4.85-11.08-10.84-11.08h0Z"
                  />
                </g>
                <ellipse
                  cx="127.43"
                  cy="171.93"
                  rx="4.97"
                  ry="5.08"
                  fill="#040403"
                />
              </g>
            </g>
            <path
              d="M134.38,163.49c-.92-.84-1.27-1.18-3.5-1.56-2.37-.4-4.14-.7-6.42-.2-.94,.2-1.8,.54-3.17,1.47-3.16,2.12-3.64,5.7-3.9,7.03-.33,1.66-.41,4.93-.5,4.28-.28-1.95,2.04-3.82,4.4-4.73,7.52-2.92,12.05-.36,12.52-.2,4.01,1.29,2.95,3.65,3.57,2.99,.37-.39,.03-2.94-1.16-5.7-1.12-2.58-1.6-3.14-1.84-3.36Z"
              fill="#040403"
            />
            <ellipse cx="133.13" cy="176.05" rx="2.2" ry="2.25" fill="#fff" />
            <ellipse
              cx="121.78"
              cy="167.65"
              rx="1.1"
              ry="1.13"
              fill="#686868"
            />
          </g>
          <path
            d="M113.83,163.25c13.75-.64,24.68,1.94,24.68,1.94,1.55,1.26,3.59,5.19,4.65,5.17s1.06-.75,1.06-.75c0,0-1.48-4.08-2.12-5.2-.81-1.43-2.03-2.05-2.03-2.05,0,0-15.12-3.17-27.41-2.49,0,0-6.04,2.9-10.52,10.19,0,0-1.06,1.8,.16,2.1,.85,.2,1.55-.52,2.6-1.92,1.87-3.03,8.92-6.98,8.92-6.98Z"
            fill="#030303"
          />
        </g>
      </g>
    </g>
    <g
      id="Eye_type_A-10-2-5-2"
      v-if="data.value === 'type-5' && data.position === 'm'"
    >
      <g>
        <path
          d="M189.89,161.43c-6.73-1.17-11.44,4.11-13.57,7.19-.92,1.33-.99,3.06-.24,4.48,1.49,2.82,4.8,7.41,11.28,9.59,9.73,3.28,21.57,2.23,29-7.47,0,0,7.23-7.93-26.47-13.79Z"
          fill="#fff"
        />
        <g>
          <g>
            <ellipse
              cx="192.35"
              cy="172.15"
              rx="10.85"
              ry="11.09"
              :fill="data.color"
            />
            <ellipse
              cx="192.35"
              cy="172.15"
              rx="10.85"
              ry="11.09"
              :fill="data.color"
              opacity=".3"
            />
            <path
              d="M192.35,162.06c5.43,0,9.85,4.52,9.85,10.09s-4.42,10.09-9.85,10.09-9.85-4.52-9.85-10.09,4.42-10.09,9.85-10.09m0-1c-5.99,0-10.85,4.96-10.85,11.09s4.86,11.09,10.85,11.09,10.85-4.96,10.85-11.09-4.86-11.09-10.85-11.09h0Z"
            />
          </g>
          <ellipse cx="192.35" cy="172.15" rx="4.98" ry="5.09" fill="#040403" />
        </g>
        <path
          d="M185.16,163.46c.92-.84,1.27-1.19,3.5-1.56,2.38-.4,4.14-.7,6.43-.2,.94,.2,1.8,.54,3.17,1.47,3.16,2.12,3.64,5.71,3.9,7.03,.33,1.66,.41,4.94,.5,4.28,.28-1.95-2.04-3.82-4.4-4.74-7.53-2.92-12.06-.36-12.53-.2-4.01,1.29-2.95,3.65-3.57,2.99-.37-.39-.03-2.94,1.16-5.7,1.12-2.58,1.6-3.14,1.84-3.36Z"
          fill="#040403"
        />
        <ellipse cx="187.26" cy="165.57" rx="2.2" ry="1.78" fill="#727272" />
        <path
          d="M175.05,169.46s2.75-8.02,18.16-9.62c11.22-.77,25.98,10.06,26.63,10.94,0,0-1.8,1.06-3.38,1.12,0,0-10.13-8.1-22.98-8.87,0,0-8.35-1.12-16.18,6.11,0,0-2.12,1.27-2.26,.32Z"
          fill="#0e0d0a"
        />
        <path
          d="M184.05,181.22s2.02,1.25,3.94,1.32c2.48,.1,10.14,1.61,17.3-.33,0,0,2.17-.69,3.47-.33,0,0-12.5,6.38-24.72-.66Z"
          fill="#494949"
        />
      </g>
      <g>
        <path
          d="M129.99,161.43c6.73-1.17,11.44,4.11,13.57,7.19,.92,1.33,.99,3.06,.24,4.48-1.49,2.82-4.8,7.41-11.28,9.59-9.73,3.28-21.57,2.23-29-7.47,0,0-7.23-7.93,26.47-13.79Z"
          fill="#fff"
        />
        <g>
          <g>
            <ellipse
              cx="127.53"
              cy="172.15"
              rx="10.85"
              ry="11.09"
              :fill="data.color"
            />
            <ellipse
              cx="127.53"
              cy="172.15"
              rx="10.85"
              ry="11.09"
              :fill="data.color"
              opacity=".3"
            />
            <path
              d="M127.53,162.06c5.43,0,9.85,4.52,9.85,10.09s-4.42,10.09-9.85,10.09-9.85-4.52-9.85-10.09,4.42-10.09,9.85-10.09m0-1c-5.99,0-10.85,4.96-10.85,11.09s4.86,11.09,10.85,11.09,10.85-4.96,10.85-11.09-4.86-11.09-10.85-11.09h0Z"
            />
          </g>
          <ellipse cx="127.53" cy="172.15" rx="4.98" ry="5.09" fill="#040403" />
        </g>
        <path
          d="M134.73,163.46c-.92-.84-1.27-1.19-3.5-1.56-2.38-.4-4.14-.7-6.43-.2-.94,.2-1.8,.54-3.17,1.47-3.16,2.12-3.64,5.71-3.9,7.03-.33,1.66-.41,4.94-.5,4.28-.28-1.95,2.04-3.82,4.4-4.74,7.53-2.92,12.06-.36,12.53-.2,4.01,1.29,2.95,3.65,3.57,2.99,.37-.39,.03-2.94-1.16-5.7-1.12-2.58-1.6-3.14-1.84-3.36Z"
          fill="#040403"
        />
        <path
          d="M144.84,169.46s-2.75-8.02-18.16-9.62c-11.22-.77-25.98,10.06-26.63,10.94,0,0,1.8,1.06,3.38,1.12,0,0,10.13-8.1,22.98-8.87,0,0,8.35-1.12,16.18,6.11,0,0,2.12,1.27,2.26,.32Z"
          fill="#0e0d0a"
        />
        <path
          d="M135.84,181.22s-2.02,1.25-3.94,1.32c-2.48,.1-10.14,1.61-17.3-.33,0,0-2.17-.69-3.47-.33,0,0,12.5,6.38,24.72-.66Z"
          fill="#494949"
        />
        <ellipse cx="123.84" cy="165.57" rx="2.2" ry="1.78" fill="#727272" />
      </g>
    </g>
    <g
      id="Eye_type_A-10-2-6-2"
      v-if="data.value === 'type-6' && data.position === 'm'"
    >
      <g>
        <g>
          <path
            d="M188.2,163.18c-12.25,.23-12.97,6.56-12.97,6.56,0,0,1.63,7.18,11.76,9.88,10.13,2.7,22.75,1.72,29.54-5.51,0,0,9.12-11.63-28.33-10.92Z"
            fill="#fff"
          />
          <g>
            <g>
              <path
                d="M200.86,165.87c-.95-1.4-2.28-2.51-3.84-3.16-2.46-.02-4.66,0-6.58,.08-1.49,.66-2.75,1.74-3.66,3.09-.94,1.41-1.5,3.11-1.5,4.95,0,4.83,3.84,8.76,8.55,8.76s8.55-3.93,8.55-8.76c0-1.84-.56-3.55-1.51-4.96Z"
                :fill="data.color"
              />
              <path
                d="M200.86,165.87c-.95-1.4-2.28-2.51-3.84-3.16-2.46-.02-4.66,0-6.58,.08-1.49,.66-2.75,1.74-3.66,3.09-.94,1.41-1.5,3.11-1.5,4.95,0,4.83,3.84,8.76,8.55,8.76s8.55-3.93,8.55-8.76c0-1.84-.56-3.55-1.51-4.96Z"
                :fill="data.color"
                opacity=".3"
              />
              <path
                d="M201.91,165.94c-.75-1.29-1.77-2.38-3-3.19-.65-.01-1.28-.02-1.9-.03,1.56,.65,2.9,1.75,3.84,3.16,.95,1.41,1.51,3.12,1.51,4.96,0,4.83-3.84,8.76-8.55,8.76s-8.55-3.93-8.55-8.76c0-1.83,.56-3.54,1.5-4.95,.91-1.35,2.17-2.43,3.66-3.09-.67,.02-1.31,.05-1.92,.09-1.15,.8-2.11,1.86-2.81,3.09-.82,1.43-1.3,3.09-1.3,4.87,0,5.32,4.22,9.63,9.42,9.63s9.42-4.31,9.42-9.63c0-1.79-.49-3.46-1.32-4.9Z"
                fill="#030302"
              />
            </g>
            <ellipse
              cx="193.82"
              cy="170.83"
              rx="4.32"
              ry="4.42"
              fill="#040403"
            />
            <ellipse cx="198.04" cy="174.37" rx="2.15" ry="1.73" fill="#888" />
          </g>
          <path
            d="M175.23,169.74s-2.6-.72,4.41-5.97c.32-.24,.71-.41,1.13-.48,2.34-.42,11.09-1.69,26.96-.71,.92,.06,1.81,.31,2.58,.75,1.94,1.09,5.77,3.53,9.05,7.34,0,0-3.66,5.8-7,6.75,0,0,4.7-3.69,3.89-6.9,0,0-6.32-3.66-11.05-4.84,0,0-15.15-1.31-24.71,.73,0,0-2.6-.07-5.26,3.33Z"
            fill="#030302"
          />
        </g>
        <g>
          <path
            d="M131.92,163.18c12.25,.23,12.97,6.56,12.97,6.56,0,0-1.63,7.18-11.76,9.88-10.13,2.7-22.75,1.72-29.54-5.51,0,0-9.12-11.63,28.33-10.92Z"
            fill="#fff"
          />
          <g>
            <g>
              <path
                d="M133.35,165.87c-.95-1.4-2.28-2.51-3.84-3.16-2.46-.02-4.66,0-6.58,.08-1.49,.66-2.75,1.74-3.66,3.09-.94,1.41-1.5,3.11-1.5,4.95,0,4.83,3.84,8.76,8.55,8.76s8.55-3.93,8.55-8.76c0-1.84-.56-3.55-1.51-4.96Z"
                :fill="data.color"
              />
              <path
                d="M133.35,165.87c-.95-1.4-2.28-2.51-3.84-3.16-2.46-.02-4.66,0-6.58,.08-1.49,.66-2.75,1.74-3.66,3.09-.94,1.41-1.5,3.11-1.5,4.95,0,4.83,3.84,8.76,8.55,8.76s8.55-3.93,8.55-8.76c0-1.84-.56-3.55-1.51-4.96Z"
                :fill="data.color"
                opacity=".3"
              />
              <path
                d="M134.4,165.94c-.75-1.29-1.77-2.38-3-3.19-.65-.01-1.28-.02-1.9-.03,1.56,.65,2.9,1.75,3.84,3.16,.95,1.41,1.51,3.12,1.51,4.96,0,4.83-3.84,8.76-8.55,8.76s-8.55-3.93-8.55-8.76c0-1.83,.56-3.54,1.5-4.95,.91-1.35,2.17-2.43,3.66-3.09-.67,.02-1.31,.05-1.92,.09-1.15,.8-2.11,1.86-2.81,3.09-.82,1.43-1.3,3.09-1.3,4.87,0,5.32,4.22,9.63,9.42,9.63s9.42-4.31,9.42-9.63c0-1.79-.49-3.46-1.32-4.9Z"
                fill="#030302"
              />
            </g>
            <ellipse
              cx="126.31"
              cy="170.83"
              rx="4.32"
              ry="4.42"
              fill="#040403"
            />
            <ellipse cx="130.53" cy="174.37" rx="2.15" ry="1.73" fill="#888" />
          </g>
          <path
            d="M144.89,169.74s2.6-.72-4.41-5.97c-.32-.24-.71-.41-1.13-.48-2.34-.42-11.09-1.69-26.96-.71-.92,.06-1.81,.31-2.58,.75-1.94,1.09-5.77,3.53-9.05,7.34,0,0,3.66,5.8,7,6.75,0,0-4.7-3.69-3.89-6.9,0,0,6.32-3.66,11.05-4.84,0,0,15.15-1.31,24.71,.73,0,0,2.6-.07,5.26,3.33Z"
            fill="#030302"
          />
        </g>
      </g>
    </g>
    <g
      id="Eye_type_A-10-2-7-2"
      v-if="data.value === 'type-7' && data.position === 'm'"
    >
      <g>
        <path
          d="M188.2,163.72c-12.25,.18-12.97,5.04-12.97,5.04,0,0,1.63,5.52,11.76,7.59,10.13,2.08,22.75,1.32,29.54-4.24,0,0,9.12-8.94-28.33-8.4Z"
          fill="#fff"
        />
        <path
          d="M201.32,165.45c-.19-.87-.52-1.69-.95-2.44-6.12-.11-10.81,.05-14.12,.27-.39,.73-.68,1.51-.84,2.35-.11,.53-.18,1.08-.18,1.65,0,4.61,3.66,8.35,8.16,8.35s8.16-3.75,8.16-8.35c0-.63-.09-1.24-.22-1.83Z"
          :fill="data.color"
        />
        <path
          d="M201.32,165.45c-.19-.87-.52-1.69-.95-2.44-6.12-.11-10.81,.05-14.12,.27-.39,.73-.68,1.51-.84,2.35-.11,.53-.18,1.08-.18,1.65,0,4.61,3.66,8.35,8.16,8.35s8.16-3.75,8.16-8.35c0-.63-.09-1.24-.22-1.83Z"
          :fill="data.color"
          opacity=".3"
        />
        <path
          d="M202.17,165.48c-.17-.87-.46-1.69-.85-2.45-.32,0-.64-.01-.95-.02,.44,.75,.76,1.56,.95,2.44,.13,.59,.22,1.2,.22,1.83,0,4.61-3.66,8.35-8.16,8.35s-8.16-3.75-8.16-8.35c0-.57,.07-1.11,.18-1.65,.17-.84,.45-1.62,.84-2.35-.34,.02-.65,.04-.96,.07-.35,.74-.6,1.53-.74,2.36-.09,.51-.15,1.03-.15,1.57,0,5.07,4.02,9.18,8.98,9.18s8.98-4.11,8.98-9.18c0-.62-.08-1.21-.19-1.79Z"
          fill="#030302"
        />
        <ellipse cx="193.38" cy="167.28" rx="4.12" ry="4.21" fill="#040403" />
        <ellipse cx="196.37" cy="170.78" rx="2.44" ry="1.04" fill="#888" />
        <path
          d="M210.31,163.83c-.77-.33-1.66-.53-2.58-.57-2.29-.11-4.41-.18-6.41-.22-.32,0-.64-.01-.95-.02-6.12-.11-10.81,.05-14.12,.27-.34,.02-.65,.04-.96,.07-2.23,.16-3.74,.34-4.52,.45-.42,.06-.8,.18-1.13,.37-7.01,4.04-4.41,4.59-4.41,4.59,2.65-2.62,5.26-2.56,5.26-2.56,1.27-.21,2.64-.37,4.06-.5,.28-.03,.57-.05,.86-.07,5.67-.44,11.97-.33,15.91-.18,.3,.01,.58,.02,.85,.03,1.87,.08,3.03,.15,3.03,.15,4.73,.9,11.05,3.72,11.05,3.72,.81,2.46-3.89,5.3-3.89,5.3,3.34-.73,7-5.19,7-5.19-3.28-2.93-7.11-4.81-9.05-5.65Z"
          fill="#030302"
        />
      </g>
      <g>
        <path
          d="M131.92,163.72c12.25,.18,12.97,5.04,12.97,5.04,0,0-1.63,5.52-11.76,7.59-10.13,2.08-22.75,1.32-29.54-4.24,0,0-9.12-8.94,28.33-8.4Z"
          fill="#fff"
        />
        <path
          d="M118.81,165.45c.19-.87,.52-1.69,.95-2.44,6.12-.11,10.81,.05,14.12,.27,.39,.73,.68,1.51,.84,2.35,.11,.53,.18,1.08,.18,1.65,0,4.61-3.66,8.35-8.16,8.35s-8.16-3.75-8.16-8.35c0-.63,.09-1.24,.22-1.83Z"
          :fill="data.color"
        />
        <path
          d="M118.81,165.45c.19-.87,.52-1.69,.95-2.44,6.12-.11,10.81,.05,14.12,.27,.39,.73,.68,1.51,.84,2.35,.11,.53,.18,1.08,.18,1.65,0,4.61-3.66,8.35-8.16,8.35s-8.16-3.75-8.16-8.35c0-.63,.09-1.24,.22-1.83Z"
          :fill="data.color"
          opacity=".3"
        />
        <path
          d="M117.95,165.48c.17-.87,.46-1.69,.85-2.45,.32,0,.64-.01,.95-.02-.44,.75-.76,1.56-.95,2.44-.13,.59-.22,1.2-.22,1.83,0,4.61,3.66,8.35,8.16,8.35s8.16-3.75,8.16-8.35c0-.57-.07-1.11-.18-1.65-.17-.84-.45-1.62-.84-2.35,.34,.02,.65,.04,.96,.07,.35,.74,.6,1.53,.74,2.36,.09,.51,.15,1.03,.15,1.57,0,5.07-4.02,9.18-8.98,9.18s-8.98-4.11-8.98-9.18c0-.62,.08-1.21,.19-1.79Z"
          fill="#030302"
        />
        <ellipse cx="126.74" cy="167.28" rx="4.12" ry="4.21" fill="#040403" />
        <ellipse cx="129.92" cy="170.78" rx="2.44" ry="1.04" fill="#888" />
        <path
          d="M109.81,163.83c.77-.33,1.66-.53,2.58-.57,2.29-.11,4.41-.18,6.41-.22,.32,0,.64-.01,.95-.02,6.12-.11,10.81,.05,14.12,.27,.34,.02,.65,.04,.96,.07,2.23,.16,3.74,.34,4.52,.45,.42,.06,.8,.18,1.13,.37,7.01,4.04,4.41,4.59,4.41,4.59-2.65-2.62-5.26-2.56-5.26-2.56-1.27-.21-2.64-.37-4.06-.5-.28-.03-.57-.05-.86-.07-5.67-.44-11.97-.33-15.91-.18-.3,.01-.58,.02-.85,.03-1.87,.08-3.03,.15-3.03,.15-4.73,.9-11.05,3.72-11.05,3.72-.81,2.46,3.89,5.3,3.89,5.3-3.34-.73-7-5.19-7-5.19,3.28-2.93,7.11-4.81,9.05-5.65Z"
          fill="#030302"
        />
      </g>
    </g>
    <g
      id="Eye_type_A-10-1-1-2"
      v-if="data.value === 'type-8' && data.position === 'm'"
    >
      <g>
        <g>
          <path
            d="M185.05,163.63l-7.53,12.55s2.41,7.13,12.33,8.11c9.93,.98,21.26-5.06,25.66-15.08,0,0-15.67-11.75-30.47-5.58Z"
            fill="#fff"
          />
          <ellipse
            cx="192.54"
            cy="171.84"
            rx="11.03"
            ry="10.46"
            transform="translate(17.06 361.07) rotate(-88.91)"
            fill="#040403"
          />
          <ellipse
            cx="192.54"
            cy="171.84"
            rx="9.43"
            ry="8.95"
            transform="translate(17.06 361.07) rotate(-88.91)"
            :fill="data.color"
          />
          <ellipse
            cx="192.54"
            cy="171.84"
            rx="9.43"
            ry="8.95"
            transform="translate(17.06 361.07) rotate(-88.91)"
            :fill="data.color"
            opacity=".3"
          />
          <ellipse
            cx="192.09"
            cy="171.66"
            rx="3.81"
            ry="3.34"
            transform="translate(16.8 360.45) rotate(-88.91)"
            fill="#232120"
          />
          <ellipse
            cx="185.87"
            cy="170.68"
            rx="1.79"
            ry="2.39"
            transform="translate(11.67 353.26) rotate(-88.91)"
            fill="#fff"
          />
          <path
            d="M176.62,172.5s-1.32,3.05,.04,4.12,3.02,.28,4.58-2.09c1.57-2.37,3.26-8.04,10.56-9.68,7.29-1.64,15.24,2.02,19.91,4.2s6.36,1.17,7.09,.26-2.62-1.55-7.73-4.86c-5.11-3.31-11.72-5.64-18.73-4.28-7.01,1.36-12.56,4.83-15.71,12.32Z"
            fill="#040403"
          />
        </g>
        <g>
          <path
            d="M134.44,163.63l7.53,12.55s-2.41,7.13-12.33,8.11c-9.93,.98-21.26-5.06-25.66-15.08,0,0,15.67-11.75,30.47-5.58Z"
            fill="#fff"
          />
          <ellipse
            cx="126.98"
            cy="171.84"
            rx="10.46"
            ry="11.03"
            transform="translate(-3.25 2.45) rotate(-1.09)"
            fill="#040403"
          />
          <ellipse
            cx="126.98"
            cy="171.84"
            rx="8.95"
            ry="9.43"
            transform="translate(-3.25 2.45) rotate(-1.09)"
            :fill="data.color"
          />
          <ellipse
            cx="126.98"
            cy="171.84"
            rx="8.95"
            ry="9.43"
            transform="translate(-3.25 2.45) rotate(-1.09)"
            :fill="data.color"
            opacity=".3"
          />
          <ellipse
            cx="127.44"
            cy="171.66"
            rx="3.34"
            ry="3.81"
            transform="translate(-3.25 2.46) rotate(-1.09)"
            fill="#232120"
          />
          <ellipse
            cx="117.8"
            cy="170.68"
            rx="2.39"
            ry="1.79"
            transform="translate(-3.23 2.28) rotate(-1.09)"
            fill="#fff"
          />
          <path
            d="M142.87,172.5s1.32,3.05-.04,4.12c-1.36,1.07-3.02,.28-4.58-2.09-1.57-2.37-3.26-8.04-10.56-9.68-7.29-1.64-15.24,2.02-19.91,4.2s-6.36,1.17-7.09,.26,2.62-1.55,7.73-4.86c5.11-3.31,11.72-5.64,18.73-4.28,7.01,1.36,12.56,4.83,15.71,12.32Z"
            fill="#040403"
          />
        </g>
      </g>
    </g>
    <g
      id="Eye_type_A-10-1-2-2"
      v-if="data.value === 'type-9' && data.position === 'm'"
    >
      <g>
        <g>
          <path
            d="M187.51,163.78c-9.24,6.2-9.12,12.18-9.12,12.18,0,0,1.74,12.04,15.27,10.54,11.97-1.33,20.89-8.36,21.3-15.44,.17-5.45-18.22-13.47-27.46-7.27Z"
            fill="#fff"
          />
          <ellipse
            cx="193.5"
            cy="173.01"
            rx="11.4"
            ry="11.55"
            transform="translate(-52.36 256.22) rotate(-60.5)"
            fill="#28201e"
          />
          <ellipse
            cx="193.5"
            cy="173.01"
            rx="9.77"
            ry="9.9"
            transform="translate(-52.36 256.22) rotate(-60.5)"
            :fill="data.color"
          />
          <ellipse
            cx="193.5"
            cy="173.01"
            rx="9.77"
            ry="9.9"
            transform="translate(-52.36 256.22) rotate(-60.5)"
            :fill="data.color"
            opacity=".3"
          />
          <ellipse
            cx="192.65"
            cy="173.04"
            rx="4.24"
            ry="5.07"
            transform="translate(-1.71 1.92) rotate(-.57)"
            fill="#28201e"
          />
          <ellipse
            cx="183.1"
            cy="172.38"
            rx="2.31"
            ry="2.78"
            transform="translate(1.6 346.43) rotate(-87.07)"
            fill="#fff"
          />
          <path
            d="M176.5,176.18h0s-.97-1.18,.64-5.25,5.28-8.15,9-10c4.04-2.01,17.5-5.25,31.61,9.37,1.42,1.47-.41,3.29-2.6,1.65-4.1-3.08-19.18-12.89-27.47-6.98h0s-3.46,2.28-5.82,8.08c0,0-2.57,6-5.35,3.13Z"
            fill="#28201e"
          />
          <path
            d="M209.59,165.17c5.89,.04,8.85-2.66,8.85-2.66,0,0-.48,3.93-4.79,5.1-3.34,.91-4.06-2.45-4.06-2.45Z"
            fill="#28201e"
          />
        </g>
        <g>
          <path
            d="M132.41,163.78c9.24,6.2,9.12,12.18,9.12,12.18,0,0-1.74,12.04-15.27,10.54-11.97-1.33-20.89-8.36-21.3-15.44-.17-5.45,18.22-13.47,27.46-7.27Z"
            fill="#fff"
          />
          <ellipse
            cx="126.43"
            cy="173.01"
            rx="11.55"
            ry="11.4"
            transform="translate(-68.8 84.69) rotate(-29.5)"
            fill="#28201e"
          />
          <ellipse
            cx="126.43"
            cy="173.01"
            rx="9.9"
            ry="9.77"
            transform="translate(-68.8 84.69) rotate(-29.5)"
            :fill="data.color"
          />
          <ellipse
            cx="126.43"
            cy="173.01"
            rx="9.9"
            ry="9.77"
            transform="translate(-68.8 84.69) rotate(-29.5)"
            :fill="data.color"
            opacity=".3"
          />
          <ellipse
            cx="127.28"
            cy="173.04"
            rx="5.07"
            ry="4.24"
            transform="translate(-47.02 298.59) rotate(-89.43)"
            fill="#28201e"
          />
          <ellipse
            cx="116.32"
            cy="171.5"
            rx="2.78"
            ry="2.31"
            transform="translate(-8.61 6.16) rotate(-2.93)"
            fill="#fff"
          />
          <path
            d="M143.42,176.18h0s.97-1.18-.64-5.25-5.28-8.15-9-10c-4.04-2.01-17.5-5.25-31.61,9.37-1.42,1.47,.41,3.29,2.6,1.65,4.1-3.08,19.18-12.89,27.47-6.98h0s3.46,2.28,5.82,8.08c0,0,2.57,6,5.35,3.13Z"
            fill="#28201e"
          />
          <path
            d="M110.33,165.17c-5.89,.04-8.85-2.66-8.85-2.66,0,0,.48,3.93,4.79,5.1,3.34,.91,4.06-2.45,4.06-2.45Z"
            fill="#28201e"
          />
        </g>
      </g>
    </g>
    <g
      id="Eye_type_A-10-1-3-2"
      v-if="data.value === 'type-10' && data.position === 'm'"
    >
      <g>
        <g>
          <path
            d="M187.6,162.8c-9.78,5.31-10.22,11.27-10.22,11.27,0,0,.6,12.15,14.22,11.92,12.05-.2,21.8-6.39,22.87-13.4,.68-5.41-17.1-15.1-26.87-9.79Z"
            fill="#fff"
          />
          <ellipse
            cx="193.59"
            cy="172.85"
            rx="10.97"
            ry="11.22"
            :fill="data.color"
          />
          <ellipse
            cx="193.59"
            cy="172.85"
            rx="10.97"
            ry="11.22"
            :fill="data.color"
            opacity=".3"
          />
          <path
            d="M193.59,184.57c-6.33,0-11.47-5.26-11.47-11.72s5.15-11.72,11.47-11.72,11.47,5.26,11.47,11.72-5.15,11.72-11.47,11.72Zm0-22.43c-5.77,0-10.47,4.81-10.47,10.72s4.7,10.72,10.47,10.72,10.47-4.81,10.47-10.72-4.7-10.72-10.47-10.72Z"
          />
          <path
            d="M193.59,164.7c-4.43,0-8.04,3.66-8.04,8.15s3.61,8.15,8.04,8.15,8.04-3.66,8.04-8.15-3.61-8.15-8.04-8.15Z"
          />
          <ellipse cx="186.8" cy="171.8" rx="3.02" ry="3.09" fill="#fff" />
          <ellipse cx="200.2" cy="176.49" rx="2.43" ry="2.49" fill="#fff" />
          <path
            d="M194.06,158.91s10.69-1.32,23.36,4.57c0,0-8.83-3.38-18.17-3.73s-5.19-.84-5.19-.84Z"
            fill="#4e484b"
          />
          <path
            d="M213.1,176.09c3.23-3.95,5.09-7.87,5.09-7.87-.17-.19-3.18-2.61-7.62-4.93,.64-.36,2.01-1.51,1.65-4.57,0,0-.8,2.73-3.24,3.78-2.75-1.31-5.92-2.49-9.24-3.09,.31-.73,.8-2.56-.5-4.88,0,0,.59,2.44-1.33,4.62-2.72-.3-5.5-.18-8.2,.64-1.34,.4-2.53,.92-3.62,1.52-2.89-.66-4.06-2.8-4.06-2.8,.42,2.06,1.65,3.18,2.54,3.74-8.08,5.61-8.49,16.14-8.49,16.14,0,0,3.51-13.65,15.48-14.1,11.01-.61,20.3,6.96,22.43,8.84,.28,.24,.34,.64,.17,.96l-1.06,2Z"
            fill="#040403"
          />
        </g>
        <g>
          <path
            d="M132.66,162.8c9.78,5.31,10.22,11.27,10.22,11.27,0,0-.6,12.15-14.22,11.92-12.05-.2-21.8-6.39-22.87-13.4-.68-5.41,17.1-15.1,26.87-9.79Z"
            fill="#fff"
          />
          <ellipse
            cx="126.64"
            cy="172.85"
            rx="10.97"
            ry="11.22"
            :fill="data.color"
          />
          <ellipse
            cx="126.64"
            cy="172.85"
            rx="10.97"
            ry="11.22"
            :fill="data.color"
            opacity=".3"
          />
          <path
            d="M126.64,184.57c-6.33,0-11.47-5.26-11.47-11.72s5.15-11.72,11.47-11.72,11.47,5.26,11.47,11.72-5.15,11.72-11.47,11.72Zm0-22.43c-5.77,0-10.47,4.81-10.47,10.72s4.7,10.72,10.47,10.72,10.47-4.81,10.47-10.72-4.7-10.72-10.47-10.72Z"
          />
          <ellipse cx="126.64" cy="172.85" rx="8.04" ry="8.15" />
          <g>
            <ellipse cx="120.61" cy="171.8" rx="3.02" ry="3.09" fill="#fff" />
            <path
              d="M131.58,176.49c0-1.37,1.09-2.49,2.43-2.49s2.43,1.11,2.43,2.49-1.09,2.49-2.43,2.49-2.43-1.11-2.43-2.49Z"
              fill="#fff"
            />
          </g>
          <path
            d="M126.19,158.91s-10.69-1.32-23.36,4.57c0,0,8.83-3.38,18.17-3.73,9.34-.35,5.19-.84,5.19-.84Z"
            fill="#4e484b"
          />
          <path
            d="M135.7,162.23c.9-.56,2.12-1.68,2.54-3.74,0,0-1.17,2.14-4.06,2.8-1.09-.6-2.29-1.12-3.62-1.52-2.7-.81-5.48-.94-8.2-.64-1.92-2.18-1.33-4.62-1.33-4.62-1.3,2.32-.8,4.15-.5,4.88-3.32,.6-6.49,1.78-9.24,3.09-2.44-1.05-3.24-3.78-3.24-3.78-.36,3.06,1.02,4.21,1.65,4.57-4.44,2.32-7.46,4.75-7.62,4.93,0,0,1.85,3.92,5.09,7.87l-1.06-2c-.17-.32-.11-.72,.17-.96,2.13-1.88,11.41-9.45,22.43-8.84,11.97,.45,15.48,14.1,15.48,14.1,0,0-.41-10.54-8.49-16.14Z"
            fill="#040403"
          />
        </g>
      </g>
    </g>
    <g
      id="Eye_type_A-10-1-4-2"
      v-if="data.value === 'type-11' && data.position === 'm'"
    >
      <g>
        <g>
          <path
            d="M186.48,163.11c-11.49,2.56-10.34,11.46-10.34,11.46,0,0,3.22,8.23,13.4,9.56,10.18,1.33,21.83-2.19,26.52-12.06,0,0,5.53-16.78-29.58-8.96Z"
            fill="#fff"
          />
          <g>
            <ellipse
              cx="192.31"
              cy="171.96"
              rx="10.84"
              ry="11.08"
              :fill="data.color"
            />
            <g opacity=".3">
              <ellipse
                cx="192.31"
                cy="171.96"
                rx="10.84"
                ry="11.08"
                :fill="data.color"
              />
            </g>
            <path
              d="M192.31,162.38c5.15,0,9.34,4.3,9.34,9.58s-4.19,9.58-9.34,9.58-9.34-4.3-9.34-9.58,4.19-9.58,9.34-9.58m0-1.5c-5.99,0-10.84,4.96-10.84,11.08s4.85,11.08,10.84,11.08,10.84-4.96,10.84-11.08-4.85-11.08-10.84-11.08h0Z"
            />
            <ellipse
              cx="192.31"
              cy="171.96"
              rx="4.97"
              ry="5.08"
              fill="#040403"
            />
          </g>
          <path
            d="M185.36,163.52c.92-.84,1.27-1.18,3.5-1.56,2.37-.4,4.14-.7,6.42-.2,.94,.2,1.8,.54,3.17,1.47,3.16,2.12,3.64,5.7,3.9,7.03,.33,1.66,.41,4.93,.5,4.28,.28-1.95-2.04-3.82-4.4-4.73-7.52-2.92-12.05-.36-12.52-.2-4.01,1.29-2.95,3.65-3.57,2.99-.37-.39-.03-2.94,1.16-5.7,1.12-2.58,1.6-3.14,1.84-3.36Z"
            fill="#040403"
          />
          <ellipse cx="196.85" cy="176.08" rx="2.2" ry="2.25" fill="#fff" />
          <ellipse cx="185.51" cy="167.68" rx="1.1" ry="1.13" fill="#686868" />
          <path
            d="M204.04,161.67c-13.61,2.04-23.84,6.69-23.84,6.69-1.27,1.53-2.52,5.79-3.56,5.97s-1.18-.53-1.18-.53c0,0,.66-4.29,1.07-5.51,.52-1.57,1.6-2.41,1.6-2.41,0,0,10.05-5.96,26.41-7.75,0,0,6.49,1.67,12.29,7.96,0,0,1.39,1.56,.25,2.09-.79,.36-1.62-.21-2.93-1.38-2.42-2.61-10.1-5.12-10.1-5.12Z"
            fill="#030303"
          />
        </g>
        <g>
          <path
            d="M133.3,163.11c11.49,2.56,10.34,11.46,10.34,11.46,0,0-3.22,8.23-13.4,9.56-10.18,1.33-21.83-2.19-26.52-12.06,0,0-5.53-16.78,29.58-8.96Z"
            fill="#fff"
          />
          <g>
            <ellipse
              cx="127.43"
              cy="171.93"
              rx="10.84"
              ry="11.08"
              :fill="data.color"
            />
            <g opacity=".3">
              <ellipse
                cx="127.43"
                cy="171.93"
                rx="10.84"
                ry="11.08"
                :fill="data.color"
              />
            </g>
            <path
              d="M127.43,162.35c5.15,0,9.34,4.3,9.34,9.58s-4.19,9.58-9.34,9.58-9.34-4.3-9.34-9.58,4.19-9.58,9.34-9.58m0-1.5c-5.99,0-10.84,4.96-10.84,11.08s4.85,11.08,10.84,11.08,10.84-4.96,10.84-11.08-4.85-11.08-10.84-11.08h0Z"
            />
            <ellipse
              cx="127.43"
              cy="171.93"
              rx="4.97"
              ry="5.08"
              fill="#040403"
            />
          </g>
          <path
            d="M134.38,163.49c-.92-.84-1.27-1.18-3.5-1.56-2.37-.4-4.14-.7-6.42-.2-.94,.2-1.8,.54-3.17,1.47-3.16,2.12-3.64,5.7-3.9,7.03-.33,1.66-.41,4.93-.5,4.28-.28-1.95,2.04-3.82,4.4-4.73,7.52-2.92,12.05-.36,12.52-.2,4.01,1.29,2.95,3.65,3.57,2.99,.37-.39,.03-2.94-1.16-5.7-1.12-2.58-1.6-3.14-1.84-3.36Z"
            fill="#040403"
          />
          <ellipse cx="133.13" cy="176.05" rx="2.2" ry="2.25" fill="#fff" />
          <ellipse cx="121.78" cy="167.65" rx="1.1" ry="1.13" fill="#686868" />
          <path
            d="M115.74,161.67c13.61,2.04,23.84,6.69,23.84,6.69,1.27,1.53,2.52,5.79,3.56,5.97s1.18-.53,1.18-.53c0,0-.66-4.29-1.07-5.51-.52-1.57-1.6-2.41-1.6-2.41,0,0-10.05-5.96-26.41-7.75,0,0-6.49,1.67-12.29,7.96,0,0-1.39,1.56-.25,2.09,.79,.36,1.62-.21,2.93-1.38,2.42-2.61,10.1-5.12,10.1-5.12Z"
            fill="#030303"
          />
        </g>
      </g>
    </g>
    <g
      id="Eye_type_A-10-1-5-2"
      v-if="data.value === 'type-12' && data.position === 'm'"
    >
      <g>
        <g>
          <g>
            <g>
              <path
                d="M188.2,162.85c-6.83-.03-10.59,5.97-12.17,9.36-.68,1.46-.47,3.18,.52,4.46,1.94,2.53,5.98,6.5,12.73,7.56,10.15,1.6,21.63-1.42,27.34-12.23,0,0,5.8-9.03-28.41-9.16Z"
                fill="#fff"
              />
              <ellipse
                cx="183.9"
                cy="173.63"
                rx="2.41"
                ry="1.8"
                transform="translate(-23.8 29.32) rotate(-8.56)"
                fill="#fff"
              />
            </g>
            <path
              d="M185.76,183.33s2.2,.89,4.11,.64c2.46-.32,10.27-.12,17-3.22,0,0,2.02-1.05,3.37-.91,0,0-11.26,8.38-24.48,3.5Z"
              fill="#494949"
            />
          </g>
          <g>
            <ellipse
              cx="192.35"
              cy="172.15"
              rx="10.85"
              ry="11.09"
              :fill="data.color"
            />
            <g opacity=".3">
              <ellipse
                cx="192.35"
                cy="172.15"
                rx="10.85"
                ry="11.09"
                :fill="data.color"
              />
            </g>
            <path
              d="M192.35,162.06c5.43,0,9.85,4.52,9.85,10.09s-4.42,10.09-9.85,10.09-9.85-4.52-9.85-10.09,4.42-10.09,9.85-10.09m0-1c-5.99,0-10.85,4.96-10.85,11.09s4.86,11.09,10.85,11.09,10.85-4.96,10.85-11.09-4.86-11.09-10.85-11.09h0Z"
            />
            <ellipse
              cx="192.35"
              cy="172.15"
              rx="4.98"
              ry="5.09"
              fill="#040403"
            />
          </g>
          <path
            d="M185.16,163.46c.92-.84,1.27-1.19,3.5-1.56,2.38-.4,4.14-.7,6.43-.2,.94,.2,1.8,.54,3.17,1.47,3.16,2.12,3.64,5.71,3.9,7.03,.33,1.66,.41,4.94,.5,4.28,.28-1.95-2.04-3.82-4.4-4.74-7.53-2.92-12.06-.36-12.53-.2-4.01,1.29-2.95,3.65-3.57,2.99-.37-.39-.03-2.94,1.16-5.7,1.12-2.58,1.6-3.14,1.84-3.36Z"
            fill="#040403"
          />
          <ellipse cx="187.26" cy="165.57" rx="2.2" ry="1.78" fill="#727272" />
          <path
            d="M174.91,173.25s1.37-8.37,16.29-12.53c10.93-2.64,27.3,5.56,28.09,6.32,0,0-1.59,1.35-3.15,1.67,0,0-11.34-6.28-24.14-4.89,0,0-8.42,.29-14.92,8.74,0,0-1.88,1.6-2.17,.69Z"
            fill="#0e0d0a"
          />
        </g>
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M131.71,162.85c6.83-.03,10.59,5.97,12.17,9.36,.68,1.46,.47,3.18-.52,4.46-1.94,2.53-5.98,6.5-12.73,7.56-10.15,1.6-21.63-1.42-27.34-12.23,0,0-5.8-9.03,28.41-9.16Z"
                  fill="#fff"
                />
                <ellipse
                  cx="136.01"
                  cy="173.63"
                  rx="1.8"
                  ry="2.41"
                  transform="translate(-55.94 282.27) rotate(-81.44)"
                  fill="#fff"
                />
              </g>
              <path
                d="M134.16,183.33s-2.2,.89-4.11,.64c-2.46-.32-10.27-.12-17-3.22,0,0-2.02-1.05-3.37-.91,0,0,11.26,8.38,24.48,3.5Z"
                fill="#494949"
              />
            </g>
            <g>
              <ellipse
                cx="127.56"
                cy="172.15"
                rx="10.85"
                ry="11.09"
                :fill="data.color"
              />
              <g opacity=".3">
                <ellipse
                  cx="127.56"
                  cy="172.15"
                  rx="10.85"
                  ry="11.09"
                  :fill="data.color"
                />
              </g>
              <path
                d="M127.56,162.06c5.43,0,9.85,4.52,9.85,10.09s-4.42,10.09-9.85,10.09-9.85-4.52-9.85-10.09,4.42-10.09,9.85-10.09m0-1c-5.99,0-10.85,4.96-10.85,11.09s4.86,11.09,10.85,11.09,10.85-4.96,10.85-11.09-4.86-11.09-10.85-11.09h0Z"
              />
              <ellipse
                cx="127.56"
                cy="172.15"
                rx="4.98"
                ry="5.09"
                fill="#040403"
              />
            </g>
            <path
              d="M134.75,163.46c-.92-.84-1.27-1.19-3.5-1.56-2.38-.4-4.14-.7-6.43-.2-.94,.2-1.8,.54-3.17,1.47-3.16,2.12-3.64,5.71-3.9,7.03-.33,1.66-.41,4.94-.5,4.28-.28-1.95,2.04-3.82,4.4-4.74,7.53-2.92,12.06-.36,12.53-.2,4.01,1.29,2.95,3.65,3.57,2.99,.37-.39,.03-2.94-1.16-5.7-1.12-2.58-1.6-3.14-1.84-3.36Z"
              fill="#040403"
            />
          </g>
          <ellipse cx="123.84" cy="165.57" rx="2.2" ry="1.78" fill="#727272" />
          <path
            d="M145,173.25s-1.37-8.37-16.29-12.53c-10.93-2.64-27.3,5.56-28.09,6.32,0,0,1.59,1.35,3.15,1.67,0,0,11.34-6.28,24.14-4.89,0,0,8.42,.29,14.92,8.74,0,0,1.88,1.6,2.17,.69Z"
            fill="#0e0d0a"
          />
        </g>
      </g>
    </g>
    <g
      id="Eye_type_A-10-1-6-2"
      v-if="data.value === 'type-13' && data.position === 'm'"
    >
      <g>
        <g>
          <path
            d="M186.9,164.82c-12.04,2.32-11.66,8.67-11.66,8.67,0,0,2.83,6.79,13.27,7.73,10.44,.94,22.71-2.18,28.17-10.46,0,0,7.01-13.02-29.78-5.94Z"
            fill="#fff"
          />
          <g>
            <path
              d="M185.83,167.3c-.67,1.56-.9,3.34-.55,5.14,.9,4.75,5.4,7.89,10.03,7.01,4.63-.88,7.67-5.45,6.77-10.2-.34-1.81-1.21-3.38-2.41-4.59-.43-.43-.91-.8-1.42-1.14l-11.4,2.02c-.4,.54-.76,1.13-1.02,1.75Z"
              :fill="data.color"
            />
            <path
              d="M185.83,167.3c-.67,1.56-.9,3.34-.55,5.14,.9,4.75,5.4,7.89,10.03,7.01,4.63-.88,7.67-5.45,6.77-10.2-.34-1.81-1.21-3.38-2.41-4.59-.43-.43-.91-.8-1.42-1.14l-11.4,2.02c-.4,.54-.76,1.13-1.02,1.75Z"
              :fill="data.color"
              opacity=".3"
            />
            <path
              d="M184.42,172.6c.99,5.22,5.93,8.67,11.04,7.71s8.45-5.99,7.46-11.21c-.33-1.76-1.12-3.31-2.21-4.57-.39-.45-.82-.84-1.28-1.21l-1.19,.21c.51,.33,.99,.7,1.42,1.14,1.2,1.21,2.06,2.78,2.41,4.59,.9,4.75-2.14,9.32-6.77,10.2-4.63,.88-9.13-2.27-10.03-7.01-.34-1.8-.11-3.58,.55-5.14,.27-.63,.62-1.21,1.02-1.75l-1.2,.21c-.34,.57-.63,1.18-.86,1.82-.54,1.56-.7,3.28-.37,5.02Z"
              fill="#030302"
            />
          </g>
          <ellipse cx="193.82" cy="170.83" rx="4.32" ry="4.42" fill="#040403" />
          <ellipse cx="198.04" cy="174.37" rx="2.15" ry="1.73" fill="#888" />
          <path
            d="M175.24,173.49s-2.69-.27,3.32-6.63c.28-.29,.63-.52,1.03-.67,2.24-.81,10.64-3.56,26.45-5.29,.91-.1,1.83,0,2.67,.3,2.09,.74,6.29,2.5,10.17,5.69,0,0-2.62,6.34-5.75,7.84,0,0,4-4.44,2.66-7.46,0,0-6.85-2.53-11.71-2.89,0,0-15.15,1.29-24.23,4.93,0,0-2.57,.37-4.61,4.18Z"
            fill="#030302"
          />
        </g>
        <g>
          <path
            d="M133.27,164.82c12.04,2.32,11.66,8.67,11.66,8.67,0,0-2.83,6.79-13.27,7.73-10.44,.94-22.71-2.18-28.17-10.46,0,0-7.01-13.02,29.78-5.94Z"
            fill="#fff"
          />
          <g>
            <path
              d="M134.34,167.3c.67,1.56,.9,3.34,.55,5.14-.9,4.75-5.4,7.89-10.03,7.01-4.63-.88-7.67-5.45-6.77-10.2,.34-1.81,1.21-3.38,2.41-4.59,.43-.43,.91-.8,1.42-1.14l11.4,2.02c.4,.54,.76,1.13,1.02,1.75Z"
              :fill="data.color"
            />
            <path
              d="M134.34,167.3c.67,1.56,.9,3.34,.55,5.14-.9,4.75-5.4,7.89-10.03,7.01-4.63-.88-7.67-5.45-6.77-10.2,.34-1.81,1.21-3.38,2.41-4.59,.43-.43,.91-.8,1.42-1.14l11.4,2.02c.4,.54,.76,1.13,1.02,1.75Z"
              :fill="data.color"
              opacity=".3"
            />
            <path
              d="M135.74,172.6c-.99,5.22-5.93,8.67-11.04,7.71s-8.45-5.99-7.46-11.21c.33-1.76,1.12-3.31,2.21-4.57,.39-.45,.82-.84,1.28-1.21l1.19,.21c-.51,.33-.99,.7-1.42,1.14-1.2,1.21-2.06,2.78-2.41,4.59-.9,4.75,2.14,9.32,6.77,10.2,4.63,.88,9.13-2.27,10.03-7.01,.34-1.8,.11-3.58-.55-5.14-.27-.63-.62-1.21-1.02-1.75l1.2,.21c.34,.57,.63,1.18,.86,1.82,.54,1.56,.7,3.28,.37,5.02Z"
              fill="#030302"
            />
          </g>
          <ellipse cx="126.35" cy="170.83" rx="4.32" ry="4.42" fill="#040403" />
          <path
            d="M144.93,173.49s2.69-.27-3.32-6.63c-.28-.29-.63-.52-1.03-.67-2.24-.81-10.64-3.56-26.45-5.29-.91-.1-1.83,0-2.67,.3-2.09,.74-6.29,2.5-10.17,5.69,0,0,2.62,6.34,5.75,7.84,0,0-4-4.44-2.66-7.46,0,0,6.85-2.53,11.71-2.89,0,0,15.15,1.29,24.23,4.93,0,0,2.57,.37,4.61,4.18Z"
            fill="#030302"
          />
          <ellipse cx="130.97" cy="174.37" rx="2.15" ry="1.73" fill="#888" />
        </g>
      </g>
    </g>
    <g
      id="Eye_type_A-10-1-7-2"
      v-if="data.value === 'type-14' && data.position === 'm'"
    >
      <g>
        <g>
          <path
            d="M187.69,164.45c-12.2,1.13-12.54,6.04-12.54,6.04,0,0,2.06,5.37,12.32,6.65,10.26,1.28,22.79-.46,29.12-6.53,0,0,8.4-9.63-28.9-6.16Z"
            fill="#fff"
          />
          <path
            d="M201.32,165.45c-.02-.11-.07-.21-.1-.32-.11,0-.21,0-.32,.01-1.12,.05-2.44,.11-3.88,.2-2.3,.14-4.91,.34-7.55,.64-1.41,.16-2.83,.34-4.21,.55-.03,.24-.04,.49-.04,.74,0,4.61,3.66,8.35,8.16,8.35s8.16-3.75,8.16-8.35c0-.63-.09-1.24-.22-1.83Z"
            :fill="data.color"
          />
          <path
            d="M201.32,165.45c-.02-.11-.07-.21-.1-.32-.11,0-.21,0-.32,.01-1.12,.05-2.44,.11-3.88,.2-2.3,.14-4.91,.34-7.55,.64-1.41,.16-2.83,.34-4.21,.55-.03,.24-.04,.49-.04,.74,0,4.61,3.66,8.35,8.16,8.35s8.16-3.75,8.16-8.35c0-.63-.09-1.24-.22-1.83Z"
            :fill="data.color"
            opacity=".3"
          />
          <path
            d="M189.26,167.28c0,2.33,1.85,4.21,4.12,4.21s4.12-1.89,4.12-4.21c0-.7-.18-1.35-.48-1.93-2.3,.14-4.91,.34-7.55,.64-.13,.41-.22,.84-.22,1.29Z"
            fill="#040403"
          />
          <path
            d="M201.22,165.13c.03,.11,.07,.21,.1,.32,.13,.59,.22,1.2,.22,1.83,0,4.61-3.66,8.35-8.16,8.35s-8.16-3.75-8.16-8.35c0-.25,.02-.5,.04-.74-.07,.01-.14,.02-.22,.03-.21,.03-.42,.07-.62,.1-.02,.2-.03,.4-.03,.61,0,5.07,4.02,9.18,8.98,9.18s8.98-4.11,8.98-9.18c0-.62-.08-1.21-.19-1.79-.03-.13-.07-.25-.1-.38-.1,0-.2,0-.31,.01-.17,0-.36,.01-.54,.02Z"
            fill="#030302"
          />
          <ellipse cx="196.37" cy="170.78" rx="2.44" ry="1.04" fill="#888" />
          <path
            d="M209.74,162.82c-.8-.27-1.7-.4-2.62-.37-2.29,.07-4.41,.17-6.41,.28-.32,.02-.64,.04-.95,.06-6.11,.37-10.77,.9-14.05,1.37-.34,.05-.64,.1-.95,.14-2.21,.34-3.7,.64-4.47,.8-.41,.09-.79,.25-1.1,.46-6.67,4.57-4.03,4.92-4.03,4.92,2.44-2.82,5.04-2.96,5.04-2.96,1.25-.31,2.6-.57,4.01-.81,.28-.05,.56-.09,.85-.14,5.62-.88,11.91-1.26,15.85-1.42,.3-.01,.58-.02,.85-.03,1.87-.07,3.04-.08,3.04-.08,4.78,.53,11.31,2.85,11.31,2.85,1,2.39-3.47,5.59-3.47,5.59,3.28-.99,6.57-5.72,6.57-5.72-3.5-2.67-7.47-4.24-9.46-4.92Z"
            fill="#030302"
          />
        </g>
        <g>
          <path
            d="M132.16,164.45c12.2,1.13,12.54,6.04,12.54,6.04,0,0-2.06,5.37-12.32,6.65-10.26,1.28-22.79-.46-29.12-6.53,0,0-8.4-9.63,28.9-6.16Z"
            fill="#fff"
          />
          <path
            d="M118.81,165.35c.02-.11,.07-.21,.1-.32,.11,0,.21,0,.32,.01,1.12,.05,2.44,.11,3.88,.2,2.3,.14,4.91,.34,7.55,.64,1.41,.16,2.83,.34,4.21,.55,.03,.24,.04,.49,.04,.74,0,4.61-3.66,8.35-8.16,8.35-4.5,0-8.16-3.75-8.16-8.35,0-.63,.09-1.24,.22-1.83Z"
            :fill="data.color"
          />
          <path
            d="M118.81,165.35c.02-.11,.07-.21,.1-.32,.11,0,.21,0,.32,.01,1.12,.05,2.44,.11,3.88,.2,2.3,.14,4.91,.34,7.55,.64,1.41,.16,2.83,.34,4.21,.55,.03,.24,.04,.49,.04,.74,0,4.61-3.66,8.35-8.16,8.35-4.5,0-8.16-3.75-8.16-8.35,0-.63,.09-1.24,.22-1.83Z"
            :fill="data.color"
            opacity=".3"
          />
          <path
            d="M130.86,167.28c0,2.33-1.85,4.21-4.12,4.21s-4.12-1.89-4.12-4.21c0-.7,.18-1.35,.48-1.93,2.3,.14,4.91,.34,7.55,.64,.13,.41,.22,.84,.22,1.29Z"
            fill="#040403"
          />
          <path
            d="M118.9,165.03c-.03,.11-.07,.21-.1,.32-.13,.59-.22,1.2-.22,1.83,0,4.61,3.66,8.35,8.16,8.35,4.5,0,8.16-3.75,8.16-8.35,0-.25-.02-.5-.04-.74,.07,.01,.14,.02,.22,.03,.21,.03,.42,.07,.62,.1,.02,.2,.03,.4,.03,.61,0,5.07-4.02,9.18-8.98,9.18s-8.98-4.11-8.98-9.18c0-.62,.08-1.21,.19-1.79,.03-.13,.07-.25,.1-.38,.1,0,.2,0,.31,.01,.17,0,.36,.01,.54,.02Z"
            fill="#030302"
          />
          <path
            d="M110.11,162.82c.8-.27,1.7-.4,2.62-.37,2.29,.07,4.41,.17,6.41,.28,.32,.02,.64,.04,.95,.06,6.11,.37,10.77,.9,14.05,1.37,.34,.05,.64,.1,.95,.14,2.21,.34,3.7,.64,4.47,.8,.41,.09,.79,.25,1.1,.46,6.67,4.57,4.03,4.92,4.03,4.92-2.44-2.82-5.04-2.96-5.04-2.96-1.25-.31-2.6-.57-4.01-.81-.28-.05-.56-.09-.85-.14-5.62-.88-11.91-1.26-15.85-1.42-.3-.01-.58-.02-.85-.03-1.87-.07-3.04-.08-3.04-.08-4.78,.53-11.31,2.85-11.31,2.85-1,2.39,3.47,5.59,3.47,5.59-3.28-.99-6.57-5.72-6.57-5.72,3.5-2.67,7.47-4.24,9.46-4.92Z"
            fill="#030302"
          />
          <ellipse cx="129.92" cy="170.78" rx="2.44" ry="1.04" fill="#888" />
        </g>
      </g>
    </g>
  </fragment>
</template>

<script>
export default {
  name: 'avatarEyeB',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
